/**
 * Leads / Contactos — quien ha preguntado por la clínica (dirección, 22/09/2026).
 *
 * «Un listado donde se va agregando pacientes que han contactado. Tiene
 * apartados cada uno nombre, teléfono, mail y motivo consulta; si alguno de
 * esos datos no los contiene el lead se quedan en blanco. Cada trabajador
 * administrativo o administrador puede contactar cualquier lead; cuando
 * contacten con un lead se marca como contactado y ya sale en rojo o tachado.»
 *
 * Tres decisiones de esta pantalla:
 *
 *  · LO QUE NO SE SABE SE QUEDA EN BLANCO. Ni «—», ni «sin nombre», ni un
 *    relleno: el hueco vacío es el dato. Quien mira la fila tiene que poder
 *    distinguir «no lo dio» de cualquier cosa que hayamos escrito nosotros.
 *  · LO PENDIENTE, DELANTE. Desde el 30/09/2026, en su propia lista (abajo).
 *  · SI LA CONSULTA FALLA, SE DICE. Una lista vacía porque el servidor no
 *    contestó se lee como «no ha llamado nadie», que es enseñar un error como
 *    si fuera un dato.
 *
 * Y de qué MARCA viene cada uno (dirección, 26/09/2026): «tienes que separar
 * los leads que vienen de [una marca] de los que vienen de [la otra]». Las
 * marcas son las de la clínica (Configuración → Marcas; las manda el servidor
 * con la lista): aquí no hay ninguna escrita. La decide el servidor con UNA regla (services/marca_lead.py: el
 * primer buzón de Mail al que escribió; si no, lo que diga «de dónde viene»);
 * aquí se pinta: una etiqueta de color en cada fila, pestañas con su número
 * arriba y la ficha, donde se asigna a mano lo que sale «Sin identificar».
 * Ningún paso nuevo para quien llama: la marca sale sola. Pestañas, solo
 * «Todos» y las marcas PROPIAS (30/09/2026: «tienen que quedar esos tres»):
 * lo de una procedencia externa o sin identificar está en «Todos», con su
 * etiqueta.
 *
 * Y los que entran SOLOS del formulario de Facebook/Instagram (27/09/2026,
 * services/meta_leads.py): en la fila y en la ficha se ve lo que eligió
 * (tratamiento, qué quiere mejorar y presupuesto), su ciudad, y de qué campaña
 * y anuncio viene.
 * Y cómo prefiere la valoración y si le parece bien pagarla (30/09/2026): con
 * eso quien reparte los contactos decide a qué profesional va cada uno (no
 * descarta a nadie). La de pago va A LA VISTA en la fila, en su distintivo,
 * con la respuesta tal cual; en la ficha, las dos con su pregunta. Igual
 * cuándo quiere operarse (02/10/2026): «Plazo», al lado del pago. Y si quiere
 * recibir ofertas (12/10/2026): «Ofertas: Sí / No», al lado, que se filtra y
 * se busca; quien dice que sí va a la lista de ofertas de Marketing (la
 * decide el servidor, services/ofertas_leads.py).
 * Con `?campana=<id de Meta>` (el enlace de «contactos recibidos» de
 * Campañas) la lista es solo la de esa campaña, y se dice arriba.
 *
 * Y los que entran SOLOS de un formulario de la web de una marca que llega al
 * buzón (28/09/2026, services/leads_desde_correo.py): llevan `correo` (el
 * correo de Mail del que salen). La fila dice «Formulario web» con lo que
 * eligió, y la ficha enlaza al correo en Mail.
 *
 * Y lo que sale de la lista SIN BORRARSE (dirección, 27/09/2026: «elimina los
 * leads que son de julio […] Y los que ya estén citados»): los DESCARTADOS
 * (se descartan desde la ficha, con un motivo, y se recuperan) y los YA
 * CITADOS (su teléfono o su correo es el de un paciente con cita; lo sabe el
 * servidor). Cada uno tiene su filtro con su número, y ninguno cuenta en «sin
 * contactar · contactados» ni en las pestañas de la lista.
 *
 * Y DOS LISTAS DE TRABAJO (dirección, 30/09/2026: «que se pueda marcar
 * contactado y pasan a una segunda lista que es contactados, y ahí se marca
 * citado o descartado»): «Pendientes» (nadie los ha contactado; el botón
 * «Contactado» los pasa a la otra) y «Contactados» (con «Citado», que los
 * pasa a «Ya citados», y «Descartar»). Cada paso se deshace: volver a
 * pendientes, «Quitar citado» y «Recuperar». Lo decide el servidor
 * (`vista=pendientes|contactados`, services/lead_estado.py).
 *
 * Y en bloque (dirección, 27/09/2026: «que se puedan marcar varios leads para
 * eliminarlos»): una casilla por fila y otra arriba para todos los que se
 * ven. «Eliminar de la lista» los DESCARTA (se recuperan en «Descartados»),
 * y en «Descartados» la misma selección los recupera.
 *
 * Y de dónde viene cada uno, su PROCEDENCIA (dirección, 27/09/2026: «tiene que
 * haber uno de campaña de [cada tratamiento] […] Luego, aparte, contacto, web
 * […] y que vayan ordenados con eso»). La decide el
 * servidor (services/procedencia_lead.py); aquí se pinta en su columna, se
 * filtra con su número (las campañas primero, luego las demás), se
 * ordena por ella y se pone a mano en la ficha o al añadir. Es otra cosa que
 * la marca, y los dos filtros se combinan. El filtro y el orden van en la URL
 * (?procedencia=campana:<tratamiento>&orden=procedencia) para poder enlazarlos
 * desde Indicadores y Campañas. Las opciones (30/09/2026) son las campañas de
 * los tratamientos que tienen campaña, Web, Instagram, TikTok y «Otras», que
 * dice cuál si se sabe («Otras: …»); salen siempre en el filtro, con su
 * número aunque sea cero. Desde el 3/11/2026 se marcan VARIAS a la vez (cada
 * botón se enciende y se apaga; «Campañas» y «Orgánico» —todo lo que no es
 * campaña— encienden o apagan su grupo de golpe) y la URL las lleva separadas
 * por comas (?procedencia=campana:rinoplastia,web); la regla de los botones,
 * en components/ProcedenciaLead.jsx (`alternarProcedencia`).
 *
 * Y LA HORA a la que entró cada uno (dirección, 30/09/2026: «no solo el día,
 * sino también la hora»), en hora de Madrid.
 *
 * Y desde el 16/10/2026 (análisis de quién se cita):
 *  · «PRIORIDAD ALTA»: los que cumplen las reglas de su campaña (las pone
 *    dirección en Campañas → «Prioridad de los contactos»; las aplica el
 *    servidor) llevan su distintivo, con el porqué al pasar por encima, y en
 *    Pendientes salen primero. Nadie se oculta y los números no cambian.
 *  · «Citado» pide la FECHA DE NACIMIENTO (o «No la sabe») y el SEXO
 *    (obligatorio, «No consta» vale): components/DialogoCitarEdadSexo.jsx.
 *  · CITADO es con una cita posterior a cuando preguntó (o marcado a mano);
 *    quien solo tiene citas de antes «Ya era paciente»: sigue en su lista,
 *    con su distintivo. La regla, en services/lead_estado.py.
 *
 * Y PARA VER, SOLO DE SUS CAMPAÑAS (administración, 22/10/2026): quien su rol
 * no entra en Leads y tiene campañas elegidas en Usuarios → «Leads: solo de
 * estas campañas» (una doctora) entra SOLO PARA VER: el servidor solo manda
 * los leads de esas campañas (services/leads_acceso.py), lo dice
 * (`solo_campanas`) y le niega toda escritura. Aquí, sin selector de campaña
 * ni de procedencia, sin ningún botón ni casilla que cambie algo, y con un
 * rótulo discreto: «Solo lectura · Solo leads de: <campaña>», con el nombre
 * que manda el servidor.
 *
 * Y QUE QUEPA (dirección, 30/09/2026: «que no haya que desplazarse para ver
 * lo de contactado»): en un portátil la fila entera, con su acción, cabe sin
 * desplazarse (lo secundario va en la segunda línea o en la ficha); en una
 * pantalla más estrecha, cada contacto es una tarjeta.
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { api } from '../lib/api';
import { error as logError } from '../lib/logger';
import { PageHeader, EmptyState } from '../components/Common';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import {
  Phone, Mail, Plus, Check, Undo2, Loader2, Trash2, UserPlus, FileText, Archive, ArchiveRestore, CalendarCheck,
  ArrowDownWideNarrow, UserCheck, MessageCircle,
} from 'lucide-react';
import { toast } from 'sonner';
import { normalizaTexto, telefonoConPrefijo, telefonoParaEnlace } from '../lib/utils';
import { useAuth } from '../lib/auth';
import { isGestion, isManagement, leadsAcotados } from '../lib/roles';
import MarcaLead, { nombreMarca, pestanasMarca } from '../components/MarcaLead';
import { estiloMarca, marcaDe, useMarcas } from '../lib/marcas';
import { EVENTO_LEADS_NUEVOS } from '../lib/leadsNuevos';
import ProcedenciaLead, {
  DetalleOtras, GRUPO_CAMPANAS, GRUPO_ORGANICO, OTRAS, PROCEDENCIAS_POR_DEFECTO, SelectorProcedencia,
  alternarProcedencia, esCampana, estadoDelGrupo, estiloProcedencia, leerProcedencias, procedenciaEncendida,
} from '../components/ProcedenciaLead';
import DialogoCitarEdadSexo from '../components/DialogoCitarEdadSexo';

function cuando(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-ES',
    { day: '2-digit', month: '2-digit', year: '2-digit' });
}

// La hora de la clínica, la vea quien la vea (30/09/2026): la de Madrid,
// con su horario de verano y de invierno.
const ZONA_CLINICA = 'Europe/Madrid';
const PARTES_EN_MADRID = new Intl.DateTimeFormat('es-ES', {
  timeZone: ZONA_CLINICA, year: 'numeric', month: 'numeric', day: 'numeric',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

function enMadrid(fecha) {
  return Object.fromEntries(PARTES_EN_MADRID.formatToParts(fecha).map((p) => [p.type, p.value]));
}

/**
 * Cuándo entró, con la hora (dirección, 30/09/2026: «no solo el día, sino
 * también la hora»): «30/9 · 14:04», en hora de Madrid. Si es de otro año
 * (o `conAno`), con el año: «30/9/2025 · 14:04».
 */
export function entradaLegible(iso, { ahora = new Date(), conAno = false } = {}) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = enMadrid(d);
  const ano = conAno || p.year !== enMadrid(ahora).year ? `/${p.year}` : '';
  return `${p.day}/${p.month}${ano} · ${p.hour}:${p.minute}`;
}

/** Cuándo entró: cuando la persona dejó sus datos (`created_at`: la hora del
 *  formulario de Meta o la del correo de la web), que es también el orden de
 *  la lista. Revisión del 30/9/2026: `entro_at` es cuándo lo recogió la app
 *  —con la lectura cada 30 min, hasta media hora tarde, y un formulario recién
 *  conectado traía su histórico con la fecha de hoy—; solo si falta la otra. */
export function entroEn(lead) {
  return lead?.created_at || lead?.entro_at || '';
}

/** Si la app lo recogió bastante después (más de 10 min) de que la persona lo
 *  dejara: «recogido en la app el …»; si no, "". */
export function recogidoDespues(lead) {
  const a = Date.parse(lead?.created_at || '');
  const b = Date.parse(lead?.entro_at || '');
  if (Number.isNaN(a) || Number.isNaN(b) || b - a <= 10 * 60 * 1000) return '';
  return `recogido en la app el ${entradaLegible(lead.entro_at, { conAno: true })}`;
}

function mensajeError(e, porDefecto) {
  return e?.response?.data?.detail || porDefecto;
}

/** «2026-10-05» y «10:00» → «05/10/2026 10:00», sin pasar por la zona horaria. */
export function fechaDeCita(fecha, hora) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(fecha || '');
  if (!m) return '';
  return `${m[3]}/${m[2]}/${m[1]}${hora ? ` ${hora}` : ''}`;
}

// Las listas (30/09/2026): las dos de trabajo, los que ya tienen cita y los
// descartados. «pendientes» es la de entrada (no va en la URL).
const VISTAS = ['pendientes', 'contactados', 'citados', 'descartados'];
// Atajos para la causa del descarte (30/09/2026): rellenan el cuadro, que se
// puede cambiar; la causa la escribe quien descarta.
export const CAUSAS_DE_DESCARTE = ['Precio', 'Le parece caro', 'No quiere pagar la valoración',
  'No le interesa', 'No contesta', 'Ya se ha operado en otro sitio'];
const EN_LA_LISTA = ['pendientes', 'contactados'];

const VACIO = {
  nombre: '', telefono: '', email: '', motivo: '', origen: '', marca: '', procedencia: '',
  procedencia_detalle: '',
};

const PLATAFORMAS = { fb: 'Facebook', ig: 'Instagram' };

/** Por dónde vino el contacto de Meta, como se lee: «Instagram». */
export function plataformaLegible(valor) {
  return PLATAFORMAS[valor] || valor || '';
}

// Una opción de lista del formulario de Meta llega como clave («algo_asi»),
// sin espacios y con guiones bajos.
const PARECE_CLAVE = /^[^\s@/:]*_[^\s@/:]*$/;

/**
 * Una respuesta del formulario de Meta como la diría una persona (28/09/2026):
 * «algo_asi» → «Algo asi», lo mismo que hace el servidor con las que no
 * reconoce (services/meta_leads.py, `_legible`). Se usa con las «otras
 * respuestas», que se guardan tal y como las da Meta: aquí solo se pintan.
 * Lo que no tiene forma de clave (un texto con espacios, un correo, un
 * enlace) sale tal cual. Si eligió varias, vienen separadas por comas.
 */
export function respuestaLegible(valor) {
  return String(valor ?? '').split(', ').map((parte) => {
    const texto = parte.trim();
    if (!PARECE_CLAVE.test(texto)) return parte;
    const limpio = texto.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
    return limpio.charAt(0).toUpperCase() + limpio.slice(1);
  }).join(', ');
}

// Las dos preguntas de la valoración (30/09/2026), como se dicen en la
// pantalla. La pregunta de verdad (con su precio) es la del formulario, y la
// guarda el servidor con el contacto (`meta.preguntas`): aquí no se escribe.
const ETIQUETA_MODALIDAD_VALORACION = 'Cómo prefiere la valoración';
const ETIQUETA_PAGO_VALORACION = 'Pago de la valoración';
// Y cuándo quiere operarse (02/10/2026, «¿Cuándo te gustaría operarte?»).
const ETIQUETA_PLAZO = 'Plazo';
// Y si quiere recibir ofertas (12/10/2026). El servidor la lee como «si» o
// «no» (`lead.ofertas`) y guarda lo que contestó (`ofertas_respuesta`) y la
// pregunta (`meta.preguntas.ofertas`).
const ETIQUETA_OFERTAS = 'Ofertas';

/**
 * «Sí», «No» o «?» (contestó, pero no se sabe leer como sí o no: no entra en
 * la lista de ofertas). "" si el formulario no lo preguntaba.
 */
export function ofertasLegible(lead) {
  if (lead?.ofertas === 'si') return 'Sí';
  if (lead?.ofertas === 'no') return 'No';
  return lead?.ofertas_respuesta ? '?' : '';
}

/** Lo que se lee al pasar por encima: la pregunta y lo que contestó. */
function tituloOfertas(lead) {
  const pregunta = lead?.meta?.preguntas?.ofertas || ETIQUETA_OFERTAS;
  const contesto = lead?.ofertas_respuesta ? `Contestó: «${lead.ofertas_respuesta}»` : '';
  const aviso = ofertasLegible(lead) === '?'
    ? 'No se sabe leer como sí o no: no entra en la lista de ofertas.'
    : '';
  return [pregunta, contesto, aviso].filter(Boolean).join('\n');
}

/** Lo que encuentra el buscador: «ofertas sí» y «ofertas: sí» (sin tildes). */
function textoOfertas(lead) {
  const ofertas = ofertasLegible(lead);
  if (ofertas === 'Sí' || ofertas === 'No') return `ofertas ${ofertas} ofertas: ${ofertas}`;
  return '';
}

// El filtro de la lista: todas, las que dijeron sí y las que dijeron no.
const FILTROS_OFERTAS = [
  { clave: '', nombre: 'Todas' },
  { clave: 'si', nombre: 'Sí' },
  { clave: 'no', nombre: 'No' },
];

const ESTILO_OFERTAS = {
  'Sí': { caja: 'border-emerald-300 bg-emerald-50 text-emerald-900', etiqueta: 'text-emerald-700' },
  No: { caja: 'border-slate-300 bg-slate-50 text-slate-800', etiqueta: 'text-slate-600' },
  '?': { caja: 'border-amber-300 bg-amber-50 text-amber-900', etiqueta: 'text-amber-700' },
};

/** Lo que el formulario de Meta dice de este contacto, para la fila. */
function DatosMeta({ lead }) {
  const meta = lead.meta;
  if (!meta) return null;
  const ofertas = ofertasLegible(lead);
  const elegido = [lead.tratamiento, lead.mejorar, lead.presupuesto, lead.modalidad_valoracion,
    lead.ciudad].filter(Boolean).join(' · ');
  const deDonde = [
    meta.campaign_name ? `Campaña «${meta.campaign_name}»` : '',
    meta.ad_name ? `anuncio «${meta.ad_name}»` : '',
    plataformaLegible(meta.plataforma),
  ].filter(Boolean).join(' · ');
  return (
    <div className="no-underline" data-testid={`lead-meta-${lead.id}`}>
      {/* Si le parece bien pagar la valoración, lo primero y en su
          distintivo: con eso se reparte el contacto. Al lado, cuándo quiere
          operarse (02/10/2026). Tal cual lo contestó; si la pantalla es
          estrecha, parte la línea en vez de taparse. */}
      {lead.pago_valoracion || lead.plazo || ofertas ? (
        <div className="mb-0.5 flex flex-wrap gap-1">
          {lead.pago_valoracion ? (
            <span data-testid={`lead-pago-valoracion-${lead.id}`}
              title={meta.preguntas?.pago_valoracion || ETIQUETA_PAGO_VALORACION}
              className={`inline-block max-w-full whitespace-normal break-words rounded border
                border-sky-300 bg-sky-50 px-1.5 py-0.5 text-xs text-sky-900`}>
              <span className="text-sky-700">{ETIQUETA_PAGO_VALORACION}:</span>{' '}
              <span className="font-medium">{lead.pago_valoracion}</span>
            </span>
          ) : null}
          {lead.plazo ? (
            <span data-testid={`lead-plazo-${lead.id}`}
              title={meta.preguntas?.plazo || ETIQUETA_PLAZO}
              className={`inline-block max-w-full whitespace-normal break-words rounded border
                border-violet-300 bg-violet-50 px-1.5 py-0.5 text-xs text-violet-900`}>
              <span className="text-violet-700">{ETIQUETA_PLAZO}:</span>{' '}
              <span className="font-medium">{lead.plazo}</span>
            </span>
          ) : null}
          {/* Si quiere recibir ofertas (12/10/2026), con la pregunta al
              pasar por encima. */}
          {ofertas ? (
            <span data-testid={`lead-ofertas-${lead.id}`} title={tituloOfertas(lead)}
              className={`inline-block max-w-full whitespace-normal break-words rounded border
                px-1.5 py-0.5 text-xs ${ESTILO_OFERTAS[ofertas].caja}`}>
              <span className={ESTILO_OFERTAS[ofertas].etiqueta}>{ETIQUETA_OFERTAS}:</span>{' '}
              <span className="font-medium">{ofertas}</span>
            </span>
          ) : null}
        </div>
      ) : null}
      {elegido ? <div className="text-sm">{elegido}</div> : null}
      {deDonde ? <div className="text-xs text-muted-foreground">{deDonde}</div> : null}
    </div>
  );
}

/**
 * Lo que dice el formulario de la web de este contacto, para la fila
 * (28/09/2026): lo que le interesa, su ciudad y que vino del formulario.
 */
function DatosFormularioWeb({ lead }) {
  if (!lead.correo?.mensaje_id || lead.meta) return null;
  const elegido = [lead.tratamiento, lead.ciudad].filter(Boolean).join(' · ');
  return (
    <div className="no-underline" data-testid={`lead-web-${lead.id}`}>
      {elegido ? <div className="text-sm">{elegido}</div> : null}
      <div className="text-xs text-muted-foreground">Formulario web</div>
    </div>
  );
}

/** El correo de Mail del que salió el lead (el formulario de la web). La
 *  bandeja lo abre al entrar; su buzón lo dice el propio correo. */
export function enlaceAlCorreo(correo) {
  if (!correo?.mensaje_id) return '';
  return `/mail?${new URLSearchParams({ mensaje: correo.mensaje_id }).toString()}`;
}

// Qué se dice cuando una pestaña no tiene a nadie.
function vacioPorMarca(marcas, clave, vista) {
  const m = marcaDe(marcas, clave);
  const quien = vista === 'contactados' ? 'Ningún contactado' : 'Ningún contacto pendiente';
  if (m) return `${quien} ${m.del || `de ${m.nombre}`}`;
  return vista === 'contactados' ? 'Ningún contactado todavía' : quien;
}

const VACIO_POR_VISTA = {
  citados: 'Ningún contacto con cita',
  descartados: 'Ningún contacto descartado',
};

const EXPLICACION_POR_VISTA = {
  pendientes: 'Aquí van apareciendo quienes preguntan por la clínica. Al marcarlos «Contactado» pasan a «Contactados».',
  contactados: 'Aquí están los que ya se han contactado: desde aquí se marcan «Citado» o se descartan.',
  citados: 'Aquí salen los contactos con una cita posterior a cuando preguntaron (por su teléfono o su correo) y los marcados «Citado». Quien ya era paciente y solo tiene citas de antes sigue en su lista, con su distintivo.',
  descartados: 'Aquí salen los contactos descartados, con su motivo, por si hay que recuperar alguno.',
};

/** El nombre de una procedencia (o de un grupo) para decirlo arriba; de
 *  varias (3/11/2026), la combinación: «Campaña rinoplastia + Web». */
function nombreDeFiltro(claves, opciones, porProcedencia) {
  const todas = [...(opciones?.campanas || []), ...(opciones?.vias || []), ...(porProcedencia || [])];
  const nombre = (clave) => {
    if (clave === GRUPO_CAMPANAS) return 'Campañas';
    if (clave === GRUPO_ORGANICO) return 'Orgánico';
    if (clave === 'sin') return 'Sin procedencia';
    return todas.find((o) => o.clave === clave)?.nombre || clave;
  };
  return (Array.isArray(claves) ? claves : leerProcedencias(claves)).map(nombre).join(' + ');
}

// Cuántos se borran como mucho de una vez (el mismo tope que el servidor).
const TOPE_BORRAR = 500;

export default function LeadsPage() {
  const { user } = useAuth();
  // Borrar es de dirección. Enseñarle la papelera a quien va a recibir un 403
  // es ofrecerle algo que no puede hacer (revisión del 22/9).
  const puedeBorrar = isManagement(user) && !leadsAcotados(user);
  // «Leads: solo de estas campañas» (22/10/2026): quien entra por el ajuste
  // solo MIRA, no elige campaña ni procedencia; las campañas (con su nombre)
  // las dice el servidor, que es quien le niega escribir.
  const acotadoPorSuFicha = leadsAcotados(user);
  const [soloCampanas, setSoloCampanas] = useState(null);
  const acotado = acotadoPorSuFicha || Array.isArray(soloCampanas);
  const soloLectura = acotado;
  const [leads, setLeads] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [fallo, setFallo] = useState(null);
  const [truncado, setTruncado] = useState(0);
  // Los recuentos los da el servidor, sobre TODA la lista (M14, 23/9/2026).
  // Contados aquí sobre la página, pasados mil la pantalla decía una cifra y
  // el marcador de Indicadores otra.
  const [recuento, setRecuento] = useState({ pendientes: 0, contactados: 0 });
  const [busca, setBusca] = useState('');
  // «Ofertas: Sí / No» (12/10/2026): filtra la lista que se ve, como el buscador.
  const [filtroOfertas, setFiltroOfertas] = useState('');
  const [abierto, setAbierto] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [nuevo, setNuevo] = useState(VACIO);
  // La pestaña de marca: todos | <cada marca propia>. Filtra el SERVIDOR,
  // que es quien sabe la marca de todos (pasados mil, la página no los trae).
  const [marca, setMarca] = useState('todos');
  // Las marcas de la clínica: las que manda la lista (las de ese momento) o,
  // hasta que llega, las de GET /api/marcas.
  const marcasPedidas = useMarcas();
  const [marcasDeLaLista, setMarcasDeLaLista] = useState(null);
  const marcas = marcasDeLaLista || marcasPedidas;
  // Cuántos hay de cada marca, sobre toda la lista (lo cuenta el servidor).
  const [porMarca, setPorMarca] = useState(null);
  // La ficha abierta (el lead entero, tal y como lo manda el servidor).
  const [ficha, setFicha] = useState(null);
  const [asignando, setAsignando] = useState(false);
  // Solo los de una campaña de Meta (27/09/2026): llega por la URL desde
  // Campañas. Filtra el SERVIDOR, que cuenta sobre la lista entera.
  const [params, setParams] = useSearchParams();
  const campana = acotadoPorSuFicha ? '' : (params.get('campana') || '').trim();
  // Qué lista: «Pendientes» (la de entrada), «Contactados», «Ya citados» o
  // «Descartados». Va en la URL (?vista=citados) para que Campañas pueda
  // enlazar sus citados.
  const vista = VISTAS.includes(params.get('vista')) ? params.get('vista') : 'pendientes';
  const enLaLista = EN_LA_LISTA.includes(vista);
  const cambiarVista = (v) => {
    const p = new URLSearchParams(params);
    if (v === 'pendientes') p.delete('vista'); else p.set('vista', v);
    setParams(p);
  };
  // Cuántos hay en cada filtro de estado y en la vista elegida (el servidor).
  const [enFiltro, setEnFiltro] = useState({
    citados: null, descartados: null, total: 0, yaPacientes: 0, sinEdadOSexo: 0,
  });
  const [descartando, setDescartando] = useState(false);
  const [citando, setCitando] = useState(false);
  // A quién se está citando (16/10/2026): el diálogo de edad y sexo. Con
  // `completar`, a un contacto ya marcado «Citado» a mano.
  const [citarA, setCitarA] = useState(null);
  // Los marcados para descartar (o recuperar) en bloque, por id.
  const [marcados, setMarcados] = useState(() => new Set());
  const [confirmarLote, setConfirmarLote] = useState(false);
  const [motivoLote, setMotivoLote] = useState('');
  // Descartar desde la fila de «Contactados» (dirección, 30/09/2026): con un
  // cuadro que pide la causa, escrita por quien descarta.
  const [descarteDe, setDescarteDe] = useState(null);
  const [motivoFila, setMotivoFila] = useState('');
  // La procedencia (27/09/2026): el filtro y el orden van en la URL; los
  // números y las opciones para ponerla a mano, los manda el servidor. Varias
  // a la vez (3/11/2026): `seleccion` son sus claves y `procedencia`, lo que
  // se pide al servidor (separadas por comas; '' es todas).
  const seleccion = acotadoPorSuFicha ? [] : leerProcedencias(params.get('procedencia'));
  const procedencia = seleccion.join(',');
  const ordenProcedencia = params.get('orden') === 'procedencia';
  const cambiarParam = (clave, valor) => {
    const p = new URLSearchParams(params);
    if (valor) p.set(clave, valor); else p.delete(clave);
    setParams(p);
  };
  const [porProcedencia, setPorProcedencia] = useState(null);
  // Los números de las cuatro listas y del contador con la marca y la
  // procedencia elegidas (3/11/2026); un servidor viejo no los manda.
  const [conFiltro, setConFiltro] = useState(null);
  const [opcionesProcedencia, setOpcionesProcedencia] = useState(PROCEDENCIAS_POR_DEFECTO);
  const [asignandoProcedencia, setAsignandoProcedencia] = useState(false);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const filtros = { vista };
      if (marca !== 'todos') filtros.marca = marca;
      if (campana) filtros.campana = campana;
      if (procedencia) filtros.procedencia = procedencia;
      if (ordenProcedencia) filtros.orden = 'procedencia';
      const r = await api.get('/api/leads', { params: filtros });
      const lista = r.data?.leads || [];
      setLeads(lista);
      // Lo marcado que ya no está en la lista (otra pestaña, otro filtro, o
      // ya descartado) deja de estar marcado: no se actúa sobre lo que no se ve.
      setMarcados((antes) => {
        const quedan = new Set(lista.map((l) => l.id));
        const siguen = [...antes].filter((id) => quedan.has(id));
        return siguen.length === antes.size ? antes : new Set(siguen);
      });
      setTruncado(r.data?.truncado ? r.data.total : 0);
      // Si un servidor viejo no los manda, se cuentan sobre lo que ha llegado.
      setRecuento({
        pendientes: r.data?.pendientes ?? lista.filter((l) => !l.contactado).length,
        contactados: r.data?.contactados ?? lista.filter((l) => l.contactado).length,
      });
      setPorMarca(r.data?.por_marca
        ? { ...r.data.por_marca, completo: r.data.por_marca_completo !== false } : null);
      if (Array.isArray(r.data?.marcas)) setMarcasDeLaLista(r.data.marcas);
      setEnFiltro({
        citados: r.data?.citados ?? null,
        descartados: r.data?.descartados ?? null,
        total: r.data?.total ?? lista.length,
        // 16/10/2026: los que ya eran pacientes (en su lista) y los citados
        // sin fecha de nacimiento o sexo. Un servidor viejo no los manda.
        yaPacientes: r.data?.ya_pacientes ?? 0,
        sinEdadOSexo: r.data?.citados_sin_edad_o_sexo ?? 0,
      });
      // Un servidor viejo no manda la procedencia: entonces no hay filtro.
      setPorProcedencia(Array.isArray(r.data?.por_procedencia) ? r.data.por_procedencia : null);
      setConFiltro(r.data?.con_filtro && typeof r.data.con_filtro === 'object' ? r.data.con_filtro : null);
      setSoloCampanas(Array.isArray(r.data?.solo_campanas) ? r.data.solo_campanas : null);
      if (r.data?.procedencias?.campanas && r.data?.procedencias?.vias) {
        setOpcionesProcedencia(r.data.procedencias);
      }
      setFallo(null);
    } catch (e) {
      logError('leads', e);
      // No se deja la lista vacía sin más: eso se leería como «no hay nadie».
      // Y si es un 403, no se invita a reintentar algo que nunca va a salir.
      setFallo({
        texto: mensajeError(e, 'No se ha podido cargar la lista de contactos'),
        sinPermiso: e?.response?.status === 403,
      });
    } finally {
      setCargando(false);
    }
  }, [marca, campana, vista, procedencia, ordenProcedencia]);

  useEffect(() => { cargar(); }, [cargar]);
  // Los teléfonos con conversación de WhatsApp (1/11/2026), para el enlace de
  // cada fila. Solo quien usa la bandeja (gestión, sin el ajuste de
  // campañas); si no se puede leer, la lista sigue igual, sin enlaces.
  const [conWhatsApp, setConWhatsApp] = useState(() => new Set());
  const veWhatsApp = isGestion(user) && !leadsAcotados(user);
  useEffect(() => {
    if (!veWhatsApp) return undefined;
    let vivo = true;
    api.get('/api/whatsapp/telefonos')
      .then((r) => {
        if (vivo && Array.isArray(r.data?.telefonos)) setConWhatsApp(new Set(r.data.telefonos));
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, [veWhatsApp]);
  // Desde una conversación de WhatsApp (?lead=<id>): se abre su ficha en
  // cuanto llega la lista, una vez.
  const leadDeLaUrl = params.get('lead');
  useEffect(() => {
    if (!leadDeLaUrl || cargando) return;
    const suyo = leads.find((l) => l.id === leadDeLaUrl);
    if (suyo) setFicha(suyo);
    const p = new URLSearchParams(params);
    p.delete('lead');
    setParams(p, { replace: true });
  }, [leadDeLaUrl, cargando, leads, params, setParams]);
  // Si entra un lead con la lista abierta (28/9/2026), suena la campanita y
  // sale el aviso (lib/leadsNuevos.js) y la lista se vuelve a cargar: aquí se
  // da por visto, así que tiene que verse.
  useEffect(() => {
    const alEntrar = () => { cargar(); };
    window.addEventListener(EVENTO_LEADS_NUEVOS, alEntrar);
    return () => window.removeEventListener(EVENTO_LEADS_NUEVOS, alEntrar);
  }, [cargar]);

  // Lo que dice el contador de al lado del buscador: el de la pestaña elegida
  // (y, con una procedencia elegida, el de esa procedencia: el servidor cuenta
  // las pestañas dentro de ella). Con la marca o la procedencia elegidas, los
  // números de lo elegido (`con_filtro`, 3/11/2026), en cualquier lista.
  const hayFiltro = marca !== 'todos' || Boolean(procedencia);
  const deLoElegido = hayFiltro ? conFiltro : null;
  const cifras = deLoElegido || (hayFiltro && porMarca?.[marca]) || recuento;
  const yaPacientes = deLoElegido ? (deLoElegido.ya_pacientes ?? 0) : enFiltro.yaPacientes;
  const sinEdadOSexo = deLoElegido ? (deLoElegido.citados_sin_edad_o_sexo ?? 0) : enFiltro.sinEdadOSexo;
  // Qué número de cada recuento es el de la lista que se ve: en las dos de
  // trabajo, sus pendientes o sus contactados; en las otras, todos.
  const campoLista = enLaLista ? vista : 'total';
  const numeroDe = (fila) => (fila ? fila[campoLista] ?? 0 : 0);
  // El filtro de procedencia (30/09/2026): TODAS las opciones, con su número
  // aunque sea cero, las campañas primero; y lo que no es ninguna opción
  // («Sin procedencia») solo si hay alguien.
  const filasProcedencia = porProcedencia || [];
  const filaDe = Object.fromEntries(filasProcedencia.map((f) => [f.clave, f]));
  const chipsDe = (opciones) => opciones.map((o) => ({ clave: o.clave, nombre: o.nombre, n: numeroDe(filaDe[o.clave]) }));
  const chipsCampanas = chipsDe(opcionesProcedencia.campanas || []);
  const chipsVias = chipsDe(opcionesProcedencia.vias || []);
  const conocidas = new Set([...chipsCampanas, ...chipsVias].map((c) => c.clave));
  filasProcedencia.filter((f) => !conocidas.has(f.clave) && (f.total > 0 || seleccion.includes(f.clave)))
    .forEach((f) => (esCampana(f.clave) ? chipsCampanas : chipsVias)
      .push({ clave: f.clave, nombre: f.nombre, n: numeroDe(f) }));
  // Lo elegido sale siempre, aunque no sea ninguna opción ni tenga a nadie:
  // así se puede apagar.
  seleccion.filter((k) => k !== GRUPO_CAMPANAS && k !== GRUPO_ORGANICO
    && ![...chipsCampanas, ...chipsVias].some((c) => c.clave === k))
    .forEach((k) => (esCampana(k) ? chipsCampanas : chipsVias)
      .push({ clave: k, nombre: nombreDeFiltro([k], opcionesProcedencia), n: 0 }));
  const sumaDe = (chips) => chips.reduce((s, c) => s + (c.n || 0), 0);
  // Cada botón se enciende y se apaga (3/11/2026); la regla, en
  // `alternarProcedencia`. La URL guarda la selección entera.
  const gruposProcedencia = {
    campanas: chipsCampanas.map((c) => c.clave), vias: chipsVias.map((c) => c.clave),
  };
  const pulsarProcedencia = (clave) => cambiarParam(
    'procedencia', alternarProcedencia(seleccion, clave, gruposProcedencia).join(','));
  const encendida = (clave) => procedenciaEncendida(seleccion, clave, gruposProcedencia);
  const hayAlguien = filasProcedencia.some((f) => f.total > 0);
  const cuantosEn = (clave) => {
    if (porMarca?.[clave]) return porMarca[clave][campoLista];
    if (clave !== 'todos') return null;
    return enLaLista ? recuento[vista] : recuento.pendientes + recuento.contactados;
  };

  const visibles = useMemo(() => {
    const q = normalizaTexto(busca.trim());
    return leads.filter((l) => {
      if (filtroOfertas && l.ofertas !== filtroOfertas) return false;
      if (!q) return true;
      // Se busca contra el número TAL Y COMO ESTÁ GUARDADO: quien teclea las
      // cifras seguidas tiene que encontrar al contacto igual. La procedencia,
      // por su nombre entero («Otras: <cuál>»). Las ofertas (12/10/2026),
      // como se leen en la fila: «ofertas sí», «ofertas: no».
      const campos = [l.nombre, l.telefono, l.email, l.motivo, l.tratamiento, l.mejorar,
        l.presupuesto, l.modalidad_valoracion, l.pago_valoracion, l.plazo, textoOfertas(l), l.ciudad,
        l.meta?.campaign_name, l.meta?.ad_name, l.procedencia?.nombre].join(' ');
      return normalizaTexto(campos).includes(q);
    });
  }, [leads, busca, filtroOfertas]);
  // Los números del filtro de ofertas, sobre la lista que ha llegado.
  const cuentaOfertas = useMemo(() => ({
    '': leads.length,
    si: leads.filter((l) => l.ofertas === 'si').length,
    no: leads.filter((l) => l.ofertas === 'no').length,
  }), [leads]);
  const hayOfertas = cuentaOfertas.si + cuentaOfertas.no > 0;

  // Marcar varios (27/09/2026). La casilla de arriba marca o desmarca TODOS
  // los que se ven ahora (la pestaña, el filtro y la búsqueda de ahora).
  const marcadosVisibles = visibles.filter((l) => marcados.has(l.id)).length;
  const todosMarcados = visibles.length > 0 && marcadosVisibles === visibles.length;
  const alternar = (id) => setMarcados((antes) => {
    const nuevo = new Set(antes);
    if (nuevo.has(id)) nuevo.delete(id); else nuevo.add(id);
    return nuevo;
  });
  const alternarTodos = () => setMarcados((antes) => {
    const nuevo = new Set(antes);
    if (todosMarcados) visibles.forEach((l) => nuevo.delete(l.id));
    else visibles.forEach((l) => nuevo.add(l.id));
    return nuevo;
  });
  const quitarSeleccion = () => setMarcados(new Set());

  const enBloque = async (accion) => {
    if (descartando || !marcados.size) return;
    setDescartando(true);
    try {
      const cuerpo = { ids: [...marcados] };
      if (accion === 'descartar' && motivoLote.trim()) cuerpo.motivo = motivoLote.trim();
      const r = await api.post(`/api/leads/${accion}`, cuerpo);
      const hechos = accion === 'descartar' ? r.data?.descartados : r.data?.recuperados;
      const resumen = r.data?.resumen || `${hechos ?? 0} ${accion === 'descartar' ? 'descartados' : 'recuperados'}`;
      // Si alguno no se ha podido, se dice cuál es el motivo (ya lo estaba…).
      if ((r.data?.no || []).length) toast.warning(resumen);
      else toast.success(accion === 'descartar'
        ? `${resumen} Se recuperan en «Descartados».` : `${resumen} Vuelven a la lista.`);
      if (r.data?.aviso) toast.warning(r.data.aviso);
      setConfirmarLote(false);
      setMotivoLote('');
      quitarSeleccion();
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, accion === 'descartar' ? 'No se ha podido descartar' : 'No se ha podido recuperar'));
    } finally {
      setDescartando(false);
    }
  };

  // Borrar DEL TODO los descartados marcados (dirección, 01/11/2026): lo mismo
  // que la papelera de cada fila, para varios a la vez, y sin vuelta atrás.
  // Solo en «Descartados» y solo para quien ve la papelera; el servidor
  // vuelve a mirar las dos cosas (y solo borra los que siguen descartados).
  const borrarSeleccionados = async () => {
    if (descartando || !marcados.size) return;
    const n = marcados.size;
    if (n > TOPE_BORRAR) {
      toast.error(`Como mucho ${TOPE_BORRAR} de una vez; has marcado ${n}. Hazlo en dos tandas.`);
      return;
    }
    const cuantos = n === 1 ? '1 contacto descartado' : `${n} contactos descartados`;
    if (!window.confirm(`¿Borrar del todo ${cuantos}?\n\nNo se puede deshacer: desaparecen de Leads y `
      + 'no se pueden recuperar. En Control rastreo queda qué era cada uno.')) return;
    setDescartando(true);
    try {
      const r = await api.post('/api/leads/borrar', { ids: [...marcados] });
      const resumen = r.data?.resumen || `${r.data?.borrados ?? 0} borrados.`;
      // Si alguno no se ha borrado (ya no estaba, lo han recuperado…), se dice.
      if ((r.data?.no || []).length) toast.warning(resumen);
      else toast.success(resumen);
      quitarSeleccion();
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido borrar'));
    } finally {
      setDescartando(false);
    }
  };

  const crear = async () => {
    if (guardando) return;
    setGuardando(true);
    try {
      // La marca y la procedencia solo van si quien lo apunta las sabe: si
      // no, las dirán su correo y «de dónde viene». El detalle, solo con «Otras».
      const {
        marca: marcaNueva, procedencia: procedenciaNueva, procedencia_detalle: detalleNuevo, ...datos
      } = nuevo;
      if (marcaNueva) datos.marca = marcaNueva;
      if (procedenciaNueva) datos.procedencia = procedenciaNueva;
      if (procedenciaNueva === OTRAS && detalleNuevo.trim()) datos.procedencia_detalle = detalleNuevo.trim();
      const r = await api.post('/api/leads', datos);
      const repes = r.data?.posibles_duplicados || [];
      toast.success(repes.length
        ? `Contacto añadido. Ojo: ya había ${repes.length} con ese teléfono o correo`
        : 'Contacto añadido');
      // Si algo no cabía, el servidor lo guarda recortado y lo dice (M9): lo
      // que dice el servidor se enseña, no se queda en la respuesta.
      if (r.data?.aviso) toast.warning(r.data.aviso);
      // Ya es paciente con cita: no sale en la lista, sino en «Ya citados».
      if (r.data?.lead?.citado) {
        toast.info(`Ya es paciente con cita (${r.data.lead.citado.paciente_nombre || 'ver ficha'}): está en «Ya citados»`);
      } else if (r.data?.lead?.ya_era_paciente) {
        // Solo con citas de antes (16/10/2026): sigue en la lista para llamarle.
        toast.info(`Ya era paciente (${r.data.lead.ya_era_paciente.paciente_nombre || 'ver ficha'}): se queda en la lista para llamarle`);
      }
      setNuevo(VACIO);
      setAbierto(false);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido añadir'));
    } finally {
      setGuardando(false);
    }
  };

  const marcar = async (lead) => {
    try {
      const r = await api.put(`/api/leads/${lead.id}/contactado`, { contactado: !lead.contactado });
      // Con la lista sin refrescar, otra persona ya lo había marcado (o
      // deshecho): el servidor no lo toca y lo dice (M10). Se enseña, y la
      // recarga de abajo pone la fila como está de verdad.
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'Ya estaba así: no se ha cambiado nada');
      else if (enLaLista) {
        // Sale de esta lista y pasa a la otra: se dice adónde (30/09/2026).
        toast.success(lead.contactado ? 'Vuelve a «Pendientes»' : 'Pasa a «Contactados»');
      }
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido marcar'));
    }
  };

  // «Citado» a mano, desde «Contactados» (30/09/2026); `false` lo quita.
  // Marcarlo pide antes la fecha de nacimiento y el sexo (16/10/2026): sin
  // `datos`, se abre el diálogo; con ellos, se cita.
  const citar = async (lead, valor, datos) => {
    if (citando) return;
    if (valor && !datos) { setCitarA({ lead, completar: false }); return; }
    setCitando(true);
    try {
      const r = await api.put(`/api/leads/${lead.id}/citado`, { citado: valor, ...(datos || {}) });
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'Ya estaba así: no se ha cambiado nada');
      else {
        const donde = r.data?.datos?.en === 'ficha'
          ? ` Edad y sexo, en la ficha de ${r.data.datos.paciente_nombre || 'su paciente'}.`
          : r.data?.datos?.en === 'contacto'
            ? ' Edad y sexo, en el contacto: pasarán a su ficha al darla de alta.' : '';
        toast.success(r.data?.completado ? `Edad y sexo guardados.${donde}`
          : valor ? `Citado: pasa a «Ya citados».${donde} Se quita desde ahí.`
            : 'Quitado de «Ya citados»: vuelve a su lista');
        if (r.data?.aviso) toast.warning(r.data.aviso);
      }
      if (r.data?.lead && ficha?.id === lead.id) setFicha(r.data.lead);
      setCitarA(null);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, valor ? 'No se ha podido marcar como citado' : 'No se ha podido quitar'));
    } finally {
      setCitando(false);
    }
  };

  // Descartar desde la fila de «Contactados» (dirección, 30/09/2026: «si
  // pulsas descartar, aparece un cuadro para que escribas la causa del
  // descarte»): abre el cuadro; el descarte es el de la ficha, con su motivo
  // obligatorio. Se recupera desde «Descartados».
  const descartarDesdeFila = (lead) => {
    setMotivoFila('');
    setDescarteDe(lead);
  };
  const confirmarDescarteFila = async () => {
    const motivo = motivoFila.trim();
    if (!descarteDe || !motivo) return;
    await descartar(descarteDe, motivo);
    setDescarteDe(null);
  };

  // Asignar la marca a mano, desde la ficha. Solo se ofrece cuando el correo
  // no la dice (lo decide el servidor: `puede_asignar_marca`). `null` la quita.
  const asignarMarca = async (lead, valor) => {
    if (asignando) return;
    setAsignando(true);
    try {
      const r = await api.put(`/api/leads/${lead.id}/marca`, { marca: valor });
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'Ya estaba así: no se ha cambiado nada');
      else toast.success(valor ? `Marca: ${nombreMarca(marcas, valor)}` : 'Marca quitada');
      if (r.data?.lead) setFicha(r.data.lead);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido asignar la marca'));
    } finally {
      setAsignando(false);
    }
  };

  // La procedencia a mano, desde la ficha (27/09/2026). `null` la quita y
  // vuelve a lo que digan su campaña de Meta y «de dónde viene». Con «Otras»,
  // cuál es (`detalle`, 30/09/2026).
  const asignarProcedencia = async (lead, valor, detalle) => {
    if (asignandoProcedencia) return;
    setAsignandoProcedencia(true);
    try {
      const cuerpo = { procedencia: valor };
      if (valor === OTRAS) cuerpo.detalle = (detalle || '').trim();
      const r = await api.put(`/api/leads/${lead.id}/procedencia`, cuerpo);
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'Ya estaba así: no se ha cambiado nada');
      else {
        toast.success(valor
          ? `Procedencia: ${r.data?.lead?.procedencia?.nombre || nombreDeFiltro(valor, opcionesProcedencia)}`
          : 'Procedencia puesta a mano quitada');
        if (r.data?.aviso) toast.warning(r.data.aviso);
      }
      if (r.data?.lead) setFicha(r.data.lead);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido poner la procedencia'));
    } finally {
      setAsignandoProcedencia(false);
    }
  };

  // Descartar (27/09/2026): sale de la lista y de los números, pero NO se
  // borra; se recupera desde «Descartados».
  const descartar = async (lead, motivo) => {
    if (descartando) return;
    setDescartando(true);
    try {
      const r = await api.put(`/api/leads/${lead.id}/descartar`, { motivo });
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'Ya estaba descartado');
      else toast.success('Contacto descartado: ya no sale en la lista. Se recupera desde «Descartados».');
      if (r.data?.aviso && !r.data?.ya_estaba) toast.warning(r.data.aviso);
      setFicha(null);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido descartar'));
    } finally {
      setDescartando(false);
    }
  };

  const recuperar = async (lead) => {
    if (descartando) return;
    setDescartando(true);
    try {
      const r = await api.put(`/api/leads/${lead.id}/recuperar`);
      if (r.data?.ya_estaba) toast.info(r.data.aviso || 'No estaba descartado');
      else toast.success('Contacto recuperado: vuelve a la lista');
      setFicha(null);
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido recuperar'));
    } finally {
      setDescartando(false);
    }
  };

  const borrar = async (lead) => {
    const quien = lead.nombre || lead.telefono || lead.email || 'este contacto';
    if (!window.confirm(`¿Borrar «${quien}» de la lista?\n\nSi ya le has llamado, márcalo como contactado en vez de borrarlo: así queda el registro.`)) return;
    try {
      await api.delete(`/api/leads/${lead.id}`);
      toast.success('Contacto borrado');
      await cargar();
    } catch (e) {
      toast.error(mensajeError(e, 'No se ha podido borrar'));
    }
  };

  // Las listas (30/09/2026), cada una con su número. Las dos de trabajo, con
  // los de la pestaña y la procedencia elegidas (los mismos del contador).
  // Desde «Ya citados» o «Descartados» con una marca o procedencia elegida, el
  // servidor solo cuenta esa vista: sus pendientes/contactados serían los de
  // dentro de ella, así que ahí no se enseña número (revisión del 30/9/2026).
  // Con `con_filtro` (3/11/2026) se saben desde cualquier lista.
  const numerosDeTrabajo = enLaLista || cifras === recuento || cifras === deLoElegido;
  const LISTAS = [
    { clave: 'pendientes', nombre: 'Pendientes', icono: UserPlus,
      n: numerosDeTrabajo ? cifras.pendientes : null,
      titulo: 'Los que nadie ha contactado todavía' },
    { clave: 'contactados', nombre: 'Contactados', icono: UserCheck,
      n: numerosDeTrabajo ? cifras.contactados : null,
      titulo: 'Los ya contactados: desde aquí se marcan «Citado» o se descartan' },
    { clave: 'citados', nombre: 'Ya citados', icono: CalendarCheck,
      n: deLoElegido ? deLoElegido.citados : enFiltro.citados,
      titulo: 'Los que ya tienen cita (o se han marcado «Citado»)' },
    { clave: 'descartados', nombre: 'Descartados', icono: Archive,
      n: deLoElegido ? deLoElegido.descartados : enFiltro.descartados,
      titulo: 'Los que se han quitado de la lista: se recuperan desde aquí' },
  ];

  return (
    <div className="p-4 sm:p-6 space-y-5" data-testid="leads-page">
      <PageHeader
        title="Leads / Contactos"
        subtitle="Quien ha preguntado por la clínica y todavía no es paciente"
        actions={acotado ? null : (
          <Button onClick={() => setAbierto(true)} className="bg-[#2E6E5E] hover:bg-[#1E4A3F]"
            data-testid="leads-nuevo">
            <Plus className="w-4 h-4 mr-2" /> Añadir contacto
          </Button>
        )}
      />

      {/* Solo los de sus campañas (22/10/2026): discreto, con el nombre que
          manda el servidor (de Campañas). Sin nada que pulsar: no se cambia. */}
      {acotado ? (
        <p className="text-xs text-muted-foreground" data-testid="leads-solo-campanas">
          <span className="font-medium" data-testid="leads-solo-lectura">Solo lectura</span>
          {' · Solo leads de: '}
          <span className="font-medium text-foreground">
            {(soloCampanas || []).map((c) => c.nombre).filter(Boolean).join(', ') || 'tus campañas'}
          </span>
        </p>
      ) : null}

      {campana && !acotado ? (
        <div className="flex flex-wrap items-center gap-3 text-sm rounded border border-[#2E6E5E]/30 bg-[#2E6E5E]/5 px-3 py-2"
          data-testid="leads-filtro-campana">
          <span>
            Solo los contactos de la campaña{' '}
            <strong>«{leads.find((l) => l.meta?.campaign_name)?.meta?.campaign_name || campana}»</strong>
            {' '}(formulario de Meta).
          </span>
          <button type="button" className="underline text-[#2E6E5E]" data-testid="leads-quitar-campana"
            onClick={() => { const p = new URLSearchParams(params); p.delete('campana'); setParams(p); }}>
            Ver todos
          </button>
          <Link to="/campanas" className="underline text-muted-foreground">Volver a Campañas</Link>
        </div>
      ) : null}

      {/* De qué marca viene: «Todos» y las marcas propias, con su número
          (26/9/2026; solo las propias desde el 30/9/2026). */}
      <div className="flex flex-wrap items-center gap-2" role="tablist" data-testid="leads-pestanas">
        {(marcas.length ? pestanasMarca(marcas) : []).map((p) => {
          const activa = marca === p.clave;
          const n = cuantosEn(p.clave);
          const m = marcaDe(marcas, p.clave);
          const color = m ? estiloMarca(m) : null;
          return (
            <button key={p.clave} type="button" role="tab" aria-selected={activa}
              data-testid={`leads-pestana-${p.clave}`}
              onClick={() => setMarca(p.clave)}
              style={activa && color ? color.chip : undefined}
              className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors ${
                activa
                  ? (color ? '' : 'bg-foreground text-background border-foreground')
                  : 'bg-background text-muted-foreground hover:text-foreground'
              }`}>
              {color ? <span aria-hidden="true" className="w-2 h-2 rounded-full" style={color.punto} /> : null}
              {p.nombre}
              {n !== null && n !== undefined ? (
                <span className="tabular-nums font-semibold" data-testid={`leads-pestana-${p.clave}-n`}>{n}</span>
              ) : null}
            </button>
          );
        })}
      </div>

      {/* Las listas (30/09/2026): las dos de trabajo y las que salen de ellas. */}
      <div className="flex flex-wrap items-center gap-2" data-testid="leads-vistas">
        {LISTAS.map(({ clave, nombre, icono: Icono, n, titulo }) => {
          const activa = vista === clave;
          return (
            <button key={clave} type="button" aria-pressed={activa} title={titulo}
              data-testid={`leads-vista-${clave}`}
              onClick={() => cambiarVista(clave)}
              className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-sm transition-colors ${
                activa ? 'bg-[#2E6E5E] text-white border-[#2E6E5E]' : 'bg-background text-muted-foreground hover:text-foreground'
              }`}>
              <Icono className="w-3.5 h-3.5" aria-hidden="true" />
              {nombre}
              {n !== null && n !== undefined ? (
                <span className="tabular-nums font-semibold" data-testid={`leads-vista-${clave}-n`}>({n})</span>
              ) : null}
            </button>
          );
        })}
      </div>

      {/* De dónde viene (27/09/2026; sus opciones, 30/09/2026): las campañas
          primero, cada una con su número; luego Web, Instagram, TikTok y
          Otras. Se combina con la pestaña de marca y vale en todas las listas.
          Varias a la vez (3/11/2026): cada botón se enciende y se apaga, y
          «Campañas» y «Orgánico» (todo lo que no es campaña) cogen su grupo
          entero; «Todas» quita la selección. */}
      {porProcedencia && (procedencia || hayAlguien) && !acotado ? (
        <div className="flex flex-wrap items-center gap-1.5" data-testid="leads-procedencias"
          role="group" aria-label="Filtrar por procedencia: se pueden marcar varias">
          <span className="text-xs font-medium text-muted-foreground mr-1">Procedencia</span>
          <ChipProcedencia clave="" nombre="Todas" n={sumaDe([...chipsCampanas, ...chipsVias])}
            activa={!seleccion.length} onClick={() => pulsarProcedencia('')}
            title="Quita la selección: todas las procedencias" />
          {chipsCampanas.length ? (
            <ChipProcedencia clave={GRUPO_CAMPANAS} nombre="Campañas" n={sumaDe(chipsCampanas)} grupo
              activa={estadoDelGrupo(seleccion, GRUPO_CAMPANAS, gruposProcedencia)}
              onClick={() => pulsarProcedencia(GRUPO_CAMPANAS)}
              title="Todas las campañas: se encienden o se apagan de golpe" />
          ) : null}
          {chipsCampanas.length || seleccion.includes(GRUPO_ORGANICO) ? (
            <ChipProcedencia clave={GRUPO_ORGANICO} nombre="Orgánico" n={sumaDe(chipsVias)} grupo
              activa={estadoDelGrupo(seleccion, GRUPO_ORGANICO, gruposProcedencia)}
              onClick={() => pulsarProcedencia(GRUPO_ORGANICO)}
              title="Todo lo que no es campaña (Web, Instagram, TikTok, Otras y Sin procedencia): se enciende o se apaga de golpe" />
          ) : null}
          {chipsCampanas.length ? <span className="mx-1 h-4 w-px bg-border" aria-hidden="true" /> : null}
          {chipsCampanas.map((c) => (
            <ChipProcedencia key={c.clave} clave={c.clave} nombre={c.nombre} n={c.n}
              activa={encendida(c.clave)} onClick={() => pulsarProcedencia(c.clave)} />
          ))}
          {chipsCampanas.length ? <span className="mx-1 h-4 w-px bg-border" aria-hidden="true" /> : null}
          {chipsVias.map((c) => (
            <ChipProcedencia key={c.clave} clave={c.clave} nombre={c.nombre} n={c.n}
              activa={encendida(c.clave)} onClick={() => pulsarProcedencia(c.clave)} />
          ))}
        </div>
      ) : null}

      {/* Si quiere recibir ofertas (12/10/2026): solo cuando algún
          contacto de la lista lo ha contestado (o el filtro está puesto). */}
      {hayOfertas || filtroOfertas ? (
        <div className="flex flex-wrap items-center gap-1.5" data-testid="leads-filtro-ofertas"
          role="group" aria-label="Filtrar por si quiere recibir ofertas">
          <span className="text-xs font-medium text-muted-foreground mr-1">{ETIQUETA_OFERTAS}</span>
          {FILTROS_OFERTAS.map(({ clave, nombre }) => (
            <button key={clave || 'todas'} type="button" aria-pressed={filtroOfertas === clave}
              data-testid={`leads-ofertas-${clave || 'todas'}`} onClick={() => setFiltroOfertas(clave)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs transition-colors ${
                filtroOfertas === clave ? 'bg-[#2E6E5E] text-white border-[#2E6E5E]'
                  : 'bg-background text-muted-foreground hover:text-foreground'}`}>
              {nombre}
              <span className="tabular-nums font-semibold" data-testid={`leads-ofertas-${clave || 'todas'}-n`}>
                {cuentaOfertas[clave]}
              </span>
            </button>
          ))}
        </div>
      ) : null}

      <div className="flex flex-wrap items-center gap-3">
        <Input value={busca} onChange={(e) => setBusca(e.target.value)}
          placeholder="Buscar por nombre, teléfono, correo, motivo o procedencia"
          className="max-w-sm" data-testid="leads-buscar" />
        <span className="text-sm text-muted-foreground" data-testid="leads-cuenta">
          {vista === 'citados' ? `${enFiltro.total} ya citados: con una cita posterior a cuando preguntaron, o marcados a mano`
            : vista === 'descartados' ? `${enFiltro.total} descartados: no salen en la lista ni en los números`
              : `${cifras.pendientes} sin contactar · ${cifras.contactados} contactados`}
          {/* Lo elegido en «Procedencia» (3/11/2026), dicho en palabras. */}
          {seleccion.length ? (
            <span data-testid="leads-procedencia-elegida">
              {' '}· procedencia: {nombreDeFiltro(seleccion, opcionesProcedencia, porProcedencia)}
            </span>
          ) : null}
          {/* 16/10/2026: discretos, para saber cuántos son sin buscarlos. */}
          {vista === 'citados' && sinEdadOSexo ? (
            <span className="text-amber-700" data-testid="leads-sin-edad-sexo"
              title="Citados sin fecha de nacimiento (ni «No la sabe») o sin sexo (ni «No consta»): los que se citan por la agenda no pasan por el diálogo. Se completan en su ficha.">
              {' '}· {sinEdadOSexo} sin edad o sexo
            </span>
          ) : null}
          {enLaLista && yaPacientes ? (
            <span data-testid="leads-ya-pacientes"
              title="Ya eran pacientes cuando preguntaron (solo tienen citas de antes): siguen en la lista para llamarles y no cuentan como citados de la campaña.">
              {' '}· {yaPacientes} ya {yaPacientes === 1 ? 'era paciente' : 'eran pacientes'}
            </span>
          ) : null}
          {porMarca && !porMarca.completo ? (
            <span className="text-amber-700" data-testid="leads-por-marca-cortado">
              {' '}· los números por marca no cuentan toda la lista
            </span>
          ) : null}
          {truncado ? (
            <span className="text-amber-700" data-testid="leads-truncado">
              {' '}· se enseñan los {leads.length} más recientes de {truncado}
            </span>
          ) : null}
        </span>
      </div>

      {marcados.size > 0 && !soloLectura ? (
        <div className="flex flex-wrap items-center gap-3 rounded-md border border-[#2E6E5E]/30 bg-[#2E6E5E]/5 px-3 py-2 text-sm"
          data-testid="leads-seleccion" role="region" aria-label="Contactos marcados">
          <span className="font-medium" data-testid="leads-seleccion-n">
            {marcados.size} {marcados.size === 1 ? 'seleccionado' : 'seleccionados'}
          </span>
          {vista === 'descartados' ? (
            <>
              <Button size="sm" variant="outline" disabled={descartando}
                data-testid="leads-seleccion-recuperar" onClick={() => enBloque('recuperar')}>
                <ArchiveRestore className="w-4 h-4 mr-1" /> Recuperar
              </Button>
              {puedeBorrar ? (
                <Button size="sm" variant="outline" disabled={descartando}
                  className="text-red-700 border-red-200 hover:bg-red-50 hover:text-red-800"
                  data-testid="leads-seleccion-borrar" onClick={borrarSeleccionados}
                  title="Los borra del todo: no se puede deshacer">
                  <Trash2 className="w-4 h-4 mr-1" /> Borrar seleccionados
                </Button>
              ) : null}
            </>
          ) : (
            <Button size="sm" variant="outline" disabled={descartando}
              data-testid="leads-seleccion-descartar" onClick={() => setConfirmarLote(true)}
              title="Van a «Descartados»: se pueden recuperar">
              <Archive className="w-4 h-4 mr-1" /> Eliminar de la lista
            </Button>
          )}
          <button type="button" className="underline text-muted-foreground hover:text-foreground"
            data-testid="leads-seleccion-quitar" onClick={quitarSeleccion}>
            Quitar selección
          </button>
        </div>
      ) : null}

      {fallo ? (
        <div className="text-sm text-red-700 border border-red-200 bg-red-50 rounded p-3"
          data-testid="leads-fallo">
          {fallo.texto}.{' '}
          {fallo.sinPermiso
            ? 'Esta lista es de administración y dirección.'
            : 'Vuelve a intentarlo; esta lista no está vacía, es que no se ha podido leer.'}
        </div>
      ) : cargando ? (
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Loader2 className="w-4 h-4 animate-spin" /> Cargando…
        </div>
      ) : visibles.length === 0 ? (
        <EmptyState icon={UserPlus}
          title={(filtroOfertas ? `Ningún contacto con «${ETIQUETA_OFERTAS}: ${filtroOfertas === 'si' ? 'Sí' : 'No'}» en esta lista` : null)
            || VACIO_POR_VISTA[vista]
            || (seleccion.length ? `Ningún contacto de «${nombreDeFiltro(seleccion, opcionesProcedencia, porProcedencia)}»` : null)
            || vacioPorMarca(marcas, marca, vista)}
          description={EXPLICACION_POR_VISTA[vista]} />
      ) : (
        <>
          {/* En la pantalla estrecha no hay cabecera: la casilla de «todos» va aquí. */}
          {soloLectura ? null : (
            <label className="xl:hidden flex items-center gap-2 text-sm text-muted-foreground">
              <input type="checkbox" checked={todosMarcados} data-testid="leads-sel-todos-tarjetas"
                onChange={alternarTodos} />
              Marcar todos los que se ven
            </label>
          )}
          {/* En un portátil (xl), una tabla que cabe entera: contacto,
              motivo, marca y procedencia, hora y la acción. Más estrecha,
              cada fila es una tarjeta (sus celdas, una debajo de otra). */}
          <div className="xl:overflow-x-auto">
            <table className="block xl:table w-full text-sm" data-testid="leads-tabla">
              <thead className="hidden xl:table-header-group">
                <tr className="text-left text-xs text-muted-foreground border-b">
                  <th className="py-2 pr-3">
                    {/* Marcar todos los que se ven (27/09/2026). */}
                    <span className="inline-flex items-center gap-2">
                      {soloLectura ? null : (
                        <input type="checkbox" checked={todosMarcados} data-testid="leads-sel-todos"
                          aria-label="Marcar todos los que se ven"
                          ref={(el) => { if (el) el.indeterminate = marcadosVisibles > 0 && !todosMarcados; }}
                          onChange={alternarTodos} />
                      )}
                      Contacto
                    </span>
                  </th>
                  <th className="py-2 pr-3">Motivo y respuestas</th>
                  {/* Ordenar por procedencia: las campañas primero (27/09/2026). */}
                  <th className="py-2 pr-3" aria-sort={ordenProcedencia ? 'ascending' : 'none'}>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      {'Marca · '}
                      <button type="button" data-testid="leads-orden-procedencia" aria-pressed={ordenProcedencia}
                        onClick={() => cambiarParam('orden', ordenProcedencia ? '' : 'procedencia')}
                        title={ordenProcedencia
                          ? 'Quitar el orden: lo más reciente arriba'
                          : 'Ordenar por procedencia: primero las campañas, luego las demás'}
                        className={`inline-flex items-center gap-1 hover:text-foreground ${ordenProcedencia ? 'text-foreground font-semibold' : ''}`}>
                        procedencia
                        <ArrowDownWideNarrow className={`w-3.5 h-3.5 ${ordenProcedencia ? '' : 'opacity-40'}`} aria-hidden="true" />
                      </button>
                    </span>
                  </th>
                  <th className="py-2 pr-3 whitespace-nowrap">Entró</th>
                  {vista === 'citados' ? <th className="py-2 pr-3">Ya citado</th> : null}
                  {vista === 'descartados' ? <th className="py-2 pr-3">Descartado</th> : null}
                  <th className="py-2 text-right"><span className="sr-only">Acciones</span></th>
                </tr>
              </thead>
              <tbody className="block xl:table-row-group space-y-2 xl:space-y-0">
                {visibles.map((l) => (
                  <FilaLead key={l.id} lead={l} vista={vista} marcas={marcas}
                    marcado={marcados.has(l.id)} onMarcar={() => alternar(l.id)}
                    onFicha={() => setFicha(l)} onContactado={() => marcar(l)}
                    onCitar={(valor) => citar(l, valor)} citando={citando}
                    onCompletar={() => setCitarA({ lead: l, completar: true })}
                    onDescartar={() => descartarDesdeFila(l)} onRecuperar={() => recuperar(l)}
                    descartando={descartando} onBorrar={puedeBorrar ? () => borrar(l) : null}
                    soloLectura={soloLectura}
                    whatsappTel={conWhatsApp.has(telefonoWhatsApp(l.telefono)) ? telefonoWhatsApp(l.telefono) : ''} />
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <Dialog open={abierto} onOpenChange={setAbierto}>
        <DialogContent className="max-w-lg" data-testid="leads-dialogo">
          <DialogHeader><DialogTitle>Añadir contacto</DialogTitle></DialogHeader>
          <p className="text-xs text-muted-foreground">
            Pon solo lo que esa persona haya dado. Lo que no sepas, déjalo en blanco:
            un hueco vacío dice «no lo dio», y cualquier relleno dice algo que no ha dicho.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <Label>Nombre</Label>
              <Input value={nuevo.nombre} data-testid="lead-nombre"
                onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })} />
            </div>
            <div>
              <Label>Teléfono</Label>
              <Input value={nuevo.telefono} data-testid="lead-telefono"
                onChange={(e) => setNuevo({ ...nuevo, telefono: e.target.value })} />
            </div>
            <div>
              <Label>Correo</Label>
              <Input value={nuevo.email} data-testid="lead-email"
                onChange={(e) => setNuevo({ ...nuevo, email: e.target.value })} />
            </div>
            <div>
              <Label>De dónde viene</Label>
              <Input value={nuevo.origen} placeholder="llamada, Instagram, web…"
                data-testid="lead-origen"
                onChange={(e) => setNuevo({ ...nuevo, origen: e.target.value })} />
            </div>
          </div>
          <div>
            <Label>Motivo de la consulta</Label>
            <Input value={nuevo.motivo} data-testid="lead-motivo"
              onChange={(e) => setNuevo({ ...nuevo, motivo: e.target.value })} />
          </div>
          {/* De dónde viene (27/09/2026): opcional. Si viene de una campaña de
              un tratamiento, aquí se dice; si no, la dirá «de dónde viene».
              Con «Otras», cuál es, si lo ha dicho (30/09/2026). */}
          <div>
            <Label htmlFor="lead-procedencia-nueva">Procedencia (si la sabes)</Label>
            <SelectorProcedencia id="lead-procedencia-nueva" testid="lead-procedencia-nueva"
              value={nuevo.procedencia} opciones={opcionesProcedencia}
              vacio="No lo sé: la dirá «de dónde viene»"
              onChange={(v) => setNuevo({ ...nuevo, procedencia: v })} />
            {nuevo.procedencia === OTRAS ? (
              <DetalleOtras id="lead-procedencia-nueva-detalle" testid="lead-procedencia-nueva-detalle"
                className="mt-2 w-full" value={nuevo.procedencia_detalle}
                onChange={(v) => setNuevo({ ...nuevo, procedencia_detalle: v })} />
            ) : null}
          </div>
          {/* Opcional: si llamó al teléfono de una de las marcas (o viene de
              una procedencia externa), quien lo apunta lo sabe. Si no, se deja
              y la marca la dirá su correo o «de dónde viene». */}
          <div>
            <Label htmlFor="lead-marca-nueva">Marca (si la sabes)</Label>
            <select id="lead-marca-nueva" value={nuevo.marca} data-testid="lead-marca-nueva"
              onChange={(e) => setNuevo({ ...nuevo, marca: e.target.value })}
              className="mt-1 block w-full h-9 rounded-md border border-input bg-background px-3 text-sm">
              <option value="">No lo sé: la dirá su correo si escribe</option>
              {marcas.map((m) => <option key={m.clave} value={m.clave}>{m.nombre}</option>)}
            </select>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAbierto(false)}>Cancelar</Button>
            <Button onClick={crear} disabled={guardando}
              className="bg-[#2E6E5E] hover:bg-[#1E4A3F]" data-testid="lead-guardar">
              {guardando ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
              Añadir
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Descartar uno desde su fila: la causa, escrita (30/09/2026). */}
      <Dialog open={!!descarteDe} onOpenChange={(abierta) => { if (!abierta) setDescarteDe(null); }}>
        <DialogContent className="max-w-md" data-testid="lead-descartar-dialogo">
          <DialogHeader>
            <DialogTitle>¿Por qué se descarta{descarteDe?.nombre ? ` a ${descarteDe.nombre}` : ''}?</DialogTitle>
          </DialogHeader>
          <div className="space-y-2">
            <Label htmlFor="lead-descartar-motivo">Causa del descarte</Label>
            <Textarea id="lead-descartar-motivo" value={motivoFila} maxLength={200} rows={3}
              autoFocus data-testid="lead-descartar-motivo"
              placeholder="Precio, no quiere pagar la valoración, le parece caro, no le interesa…"
              onChange={(e) => setMotivoFila(e.target.value)} />
            <div className="flex flex-wrap gap-1.5" data-testid="lead-descartar-sugerencias">
              {CAUSAS_DE_DESCARTE.map((c) => (
                <button key={c} type="button"
                  className="rounded-full border px-2 py-0.5 text-xs text-muted-foreground hover:text-foreground hover:border-foreground"
                  onClick={() => setMotivoFila(c)}>{c}</button>
              ))}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDescarteDe(null)}
              data-testid="lead-descartar-cancelar">Cancelar</Button>
            <Button onClick={confirmarDescarteFila} disabled={descartando || !motivoFila.trim()}
              data-testid="lead-descartar-confirmar">
              {descartando ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Archive className="w-4 h-4 mr-2" />}
              Descartar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Eliminar varios de la lista: se DESCARTAN, y se dice antes. */}
      <Dialog open={confirmarLote} onOpenChange={(abierta) => { if (!abierta) setConfirmarLote(false); }}>
        <DialogContent className="max-w-md" data-testid="leads-lote-dialogo">
          <DialogHeader>
            <DialogTitle>
              ¿Descartar {marcados.size} {marcados.size === 1 ? 'lead' : 'leads'}?
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground" data-testid="leads-lote-texto">
            Saldrán de la lista; se pueden recuperar en Descartados.
          </p>
          <div>
            <Label htmlFor="leads-lote-motivo">Motivo (opcional)</Label>
            <Input id="leads-lote-motivo" value={motivoLote} maxLength={200}
              data-testid="leads-lote-motivo" placeholder="Ya no vale, spam, repetido…"
              onChange={(e) => setMotivoLote(e.target.value)} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setConfirmarLote(false)}
              data-testid="leads-lote-cancelar">Cancelar</Button>
            <Button onClick={() => enBloque('descartar')} disabled={descartando}
              data-testid="leads-lote-confirmar">
              {descartando ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Archive className="w-4 h-4 mr-2" />}
              Descartar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <FichaLead lead={ficha} marcas={marcas} onClose={() => setFicha(null)}
        asignando={asignando} onAsignar={asignarMarca}
        opcionesProcedencia={opcionesProcedencia}
        asignandoProcedencia={asignandoProcedencia} onAsignarProcedencia={asignarProcedencia}
        citando={citando} onCitar={citar}
        descartando={descartando} onDescartar={descartar} onRecuperar={recuperar}
        soloLectura={soloLectura} />

      {/* Edad y sexo al marcar «Citado» (16/10/2026). */}
      {citarA ? (
        <DialogoCitarEdadSexo lead={citarA.lead} completar={citarA.completar} guardando={citando}
          onCerrar={() => setCitarA(null)} onConfirmar={(datos) => citar(citarA.lead, true, datos)} />
      ) : null}
    </div>
  );
}

/** Un botón del filtro de procedencia, con su número: un interruptor
 *  (aria-pressed). Los de grupo («Campañas», «Orgánico») van en negrita:
 *  cogen el grupo entero; con solo parte de él encendida, «mixed» (3/11/2026).
 *  En el móvil, un poco más altos, para el dedo. */
function ChipProcedencia({ clave, nombre, n, activa, onClick, grupo = false, title }) {
  const testid = `leads-procedencia-${clave || 'todas'}`;
  const estilo = clave && !grupo ? estiloProcedencia(clave) : 'bg-background text-muted-foreground';
  const aMedias = activa === 'mixed';
  let color = `${estilo} hover:text-foreground`;
  if (aMedias) color = 'bg-[#2E6E5E]/10 text-[#2E6E5E] border-[#2E6E5E]/50';
  else if (activa) color = 'bg-[#2E6E5E] text-white border-[#2E6E5E]';
  return (
    <button type="button" aria-pressed={aMedias ? 'mixed' : Boolean(activa)} data-testid={testid}
      onClick={onClick} title={title}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 sm:py-0.5 text-xs transition-colors ${
        color} ${grupo ? 'font-semibold' : ''} ${n || activa ? '' : 'opacity-70'}`}>
      {nombre}
      <span className="tabular-nums font-semibold" data-testid={`${testid}-n`}>{n}</span>
    </button>
  );
}

/**
 * El teléfono de un lead como lo escribe WhatsApp (E.164 sin «+»), para
 * saber si tiene conversación (1/11/2026). La MISMA idea que la regla de la
 * casa del servidor (services/telefonos.para_whatsapp): si trae el país
 * («+351…», «0044…») se respeta; nueve cifras sin país que pueden ser de
 * España, con su 34; lo demás, nada (mejor sin enlace que con el de otro).
 */
export function telefonoWhatsApp(telefono) {
  const crudo = String(telefono || '').trim();
  let cifras = crudo.replace(/[^0-9]/g, '');
  let conPais = crudo.startsWith('+');
  if (cifras.startsWith('00')) { cifras = cifras.slice(2); conPais = true; }
  if (!cifras) return '';
  if (!conPais) {
    if (cifras.length === 9) return /^[6-9]/.test(cifras) ? `34${cifras}` : '';
    if (cifras.length === 11 && cifras.startsWith('34')) return cifras;
    return '';
  }
  return cifras.length >= 8 && cifras.length <= 15 ? cifras : '';
}

// Una celda de la fila: en la tarjeta (pantalla estrecha), una debajo de
// otra; en el portátil, su columna.
const CELDA = 'block xl:table-cell py-1 xl:py-2 xl:pr-3 align-top';

/**
 * Una fila de la lista (30/09/2026): lo importante a la vista y la acción
 * de su lista al final, sin desplazarse. Lo que no dio sale en blanco.
 */
function FilaLead({
  lead: l, vista, marcas, marcado, onMarcar, onFicha, onContactado, onCitar, citando,
  onDescartar, onRecuperar, descartando, onBorrar, onCompletar, soloLectura = false,
  whatsappTel = '',
}) {
  // Solo lectura (22/10/2026, quien entra en Leads por el ajuste de campañas):
  // ni casilla ni acciones; solo la ficha, para mirar.
  const enLaLista = !soloLectura && (EN_LA_LISTA.includes(vista) || vista === 'citados');
  const deshacer = 'Deshacer contactado: vuelve a «Pendientes»';
  const quienContacto = l.contactado_via === 'conector' ? 'el conector' : (l.contactado_por_nombre || '');
  return (
    <tr data-testid={`lead-${l.id}`}
      className="block xl:table-row rounded-lg border p-3 xl:rounded-none xl:border-0 xl:border-b xl:p-0 xl:last:border-0">
      {/* Quién es y cómo llamarle. La casilla, para marcar varios. */}
      <td className={CELDA}>
        <div className="flex items-start gap-2">
          {soloLectura ? null : (
            <input type="checkbox" className="mt-1" checked={marcado} data-testid={`lead-sel-${l.id}`}
              aria-label={`Marcar ${l.nombre || l.email || 'este contacto'}`} onChange={onMarcar} />
          )}
          <div className="min-w-0">
            {/* Un hueco vacío es el dato: esa persona no lo dio. */}
            <div className="font-medium break-words" data-testid={`lead-nombre-${l.id}`}>{l.nombre}</div>
            {/* Prioridad alta (solo en las dos listas de trabajo) y «ya era
                paciente» (16/10/2026). */}
            {l.prioridad || l.ya_era_paciente ? (
              <div className="mt-0.5 flex flex-wrap gap-1">
                {EN_LA_LISTA.includes(vista)
                  ? <PrioridadAlta prioridad={l.prioridad} testid={`lead-prioridad-${l.id}`} /> : null}
                <YaEraPaciente previo={l.ya_era_paciente} testid={`lead-ya-paciente-${l.id}`} />
              </div>
            ) : null}
            <div className="tabular-nums" data-testid={`lead-telefono-${l.id}`}>
              {l.telefono ? (
                <a href={`tel:${telefonoParaEnlace(l.telefono)}`}
                  className="inline-flex items-center gap-1 whitespace-nowrap hover:underline">
                  {/* Con su prefijo, como en toda la casa: un número sin
                      prefijo no se puede llamar desde el móvil. */}
                  <Phone className="w-3 h-3" />{telefonoConPrefijo(l.telefono)}
                </a>
              ) : ''}
              {/* Si ya ha hablado por WhatsApp (1/11/2026): a su conversación. */}
              {whatsappTel ? (
                <Link to={`/whatsapp?tel=${whatsappTel}`} data-testid={`lead-whatsapp-${l.id}`}
                  title="Abrir su conversación de WhatsApp"
                  className="ml-2 inline-flex items-center gap-1 text-xs text-[#2E6E5E] hover:underline whitespace-nowrap">
                  <MessageCircle className="w-3 h-3" />WhatsApp
                </Link>
              ) : null}
            </div>
            <div className="text-xs" data-testid={`lead-email-${l.id}`}>
              {l.email ? (
                <a href={`mailto:${l.email}`} title={l.email}
                  className="inline-flex max-w-[15rem] xl:max-w-[11rem] items-center gap-1 hover:underline">
                  <Mail className="w-3 h-3 shrink-0" /><span className="truncate">{l.email}</span>
                </a>
              ) : ''}
            </div>
          </div>
        </div>
      </td>
      {/* Lo que pide y lo que respondió (el pago de la valoración, a la vista). */}
      <td className={`${CELDA} xl:max-w-[24rem] break-words`} data-testid={`lead-motivo-${l.id}`}>
        {l.motivo}
        {/* Lo que eligió en el formulario de Meta, y de qué campaña. */}
        <DatosMeta lead={l} />
        {/* O en el formulario de la web (28/09/2026). */}
        <DatosFormularioWeb lead={l} />
      </td>
      {/* De qué marca y de dónde viene. Pulsar la marca abre la ficha. */}
      <td className={CELDA}>
        <div className="flex flex-wrap xl:flex-col items-start gap-1">
          <MarcaLead marca={l.marca} onClick={onFicha} marcas={marcas}
            testid={`lead-marca-${l.id}`} title={l.marca_explicacion || 'Ver la ficha'} />
          <span className="max-w-full xl:max-w-[11rem]" data-testid={`lead-procedencia-${l.id}`}>
            <ProcedenciaLead procedencia={l.procedencia} testid={`lead-procedencia-chip-${l.id}`} />
          </span>
        </div>
      </td>
      {/* Cuándo entró, con la hora (30/09/2026); y, si ya se le contactó,
          quién y cuándo. */}
      <td className={`${CELDA} text-xs text-muted-foreground`}>
        <span className="whitespace-nowrap tabular-nums" data-testid={`lead-entro-${l.id}`}
          title={entroEn(l)
            ? `Entró el ${entradaLegible(entroEn(l), { conAno: true })} (hora de Madrid)${recogidoDespues(l) ? `; ${recogidoDespues(l)}` : ''}`
            : undefined}>
          <span className="xl:hidden">Entró </span>{entradaLegible(entroEn(l))}
        </span>
        {l.contactado ? (
          <span className="block text-red-700 xl:max-w-[8rem]" data-testid={`lead-contactado-${l.id}`}
            title="Contactado">
            <Check className="inline w-3 h-3 mr-0.5" aria-hidden="true" />{quienContacto}
            {l.contactado_at ? (
              <span className="block whitespace-nowrap tabular-nums">{entradaLegible(l.contactado_at)}</span>
            ) : null}
          </span>
        ) : null}
      </td>
      {vista === 'citados' ? (
        <td className={`${CELDA} text-xs`} data-testid={`lead-citado-${l.id}`}>
          <CitaDelLead citado={l.citado} />
          <CitadoAMano marca={l.citado_a_mano} />
          <SinEdadOSexo edadSexo={l.edad_sexo} testid={`lead-sin-edad-sexo-${l.id}`} />
        </td>
      ) : null}
      {vista === 'descartados' ? (
        <td className={`${CELDA} text-xs xl:max-w-xs`} data-testid={`lead-descartado-${l.id}`}>
          <DescarteDelLead descartado={l.descartado} />
        </td>
      ) : null}
      {/* La acción de su lista, al final y siempre a la vista: arriba la de
          su lista; debajo, deshacer, la ficha y borrar, en pequeño. */}
      <td className={`${CELDA} xl:pr-0`}>
        <div className="flex flex-wrap items-center justify-end gap-1 xl:flex-col xl:items-end">
          <div className="flex flex-wrap justify-end gap-1 xl:flex-nowrap">
            {vista === 'descartados' && !soloLectura ? (
              <Button variant="outline" size="sm" onClick={onRecuperar} disabled={descartando}
                data-testid={`lead-recuperar-${l.id}`} title="Vuelve a la lista">
                <ArchiveRestore className="w-4 h-4 mr-1" /> Recuperar
              </Button>
            ) : null}
            {enLaLista && !l.contactado ? (
              <Button variant="outline" size="sm" onClick={onContactado} data-testid={`lead-marcar-${l.id}`}
                title="Ya he hablado con esta persona: pasa a «Contactados»">
                <Check className="w-4 h-4 mr-1" /> Contactado
              </Button>
            ) : null}
            {vista === 'contactados' && l.contactado && !soloLectura ? (
              <>
                <Button variant="outline" size="sm" onClick={() => onCitar(true)} disabled={citando}
                  data-testid={`lead-citar-${l.id}`} title="Ya tiene cita: pasa a «Ya citados»">
                  <CalendarCheck className="w-4 h-4 mr-1" /> Citado
                </Button>
                <Button variant="outline" size="sm" onClick={onDescartar} disabled={descartando}
                  data-testid={`lead-descartar-${l.id}`} title="Sale de la lista: se recupera desde «Descartados»">
                  <Archive className="w-4 h-4 mr-1" /> Descartar
                </Button>
              </>
            ) : null}
            {vista === 'citados' && l.citado_a_mano?.at && !soloLectura ? (
              <Button variant="outline" size="sm" onClick={() => onCitar(false)} disabled={citando}
                data-testid={`lead-quitar-citado-${l.id}`} title="Se marcó por error: vuelve a su lista">
                <Undo2 className="w-4 h-4 mr-1" /> Quitar citado
              </Button>
            ) : null}
            {/* Marcado a mano sin edad o sexo (16/10/2026): se completa aquí. */}
            {vista === 'citados' && l.citado_a_mano?.at && onCompletar && !soloLectura
              && l.edad_sexo && !(l.edad_sexo.fecha && l.edad_sexo.sexo) ? (
                <Button variant="outline" size="sm" onClick={onCompletar} disabled={citando}
                  data-testid={`lead-completar-edad-${l.id}`} title="Su fecha de nacimiento y su sexo">
                  Completar edad y sexo
                </Button>
              ) : null}
          </div>
          <div className="flex items-center justify-end gap-0.5">
            {EN_LA_LISTA.includes(vista) && l.contactado && !soloLectura ? (
              <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={onContactado}
                data-testid={`lead-marcar-${l.id}`} title={deshacer} aria-label={deshacer}>
                <Undo2 className="w-4 h-4" />
              </Button>
            ) : null}
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={onFicha}
              data-testid={`lead-ficha-abrir-${l.id}`} title="Ver la ficha" aria-label="Ver la ficha">
              <FileText className="w-4 h-4" />
            </Button>
            {onBorrar && !soloLectura ? (
              <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={onBorrar}
                data-testid={`lead-borrar-${l.id}`} title="Borrar de la lista" aria-label="Borrar de la lista">
                <Trash2 className="w-4 h-4" />
              </Button>
            ) : null}
          </div>
        </div>
      </td>
    </tr>
  );
}

/** La cita por la que el contacto ya es paciente: su ficha, cuándo y en
 *  qué agenda (05/10/2026, dirección: «que ponga también en qué agenda se ha
 *  citado»). */
function CitaDelLead({ citado }) {
  if (!citado) return null;
  // `sin_detalle` (22/10/2026): quien entra en Leads por el ajuste de campañas
  // y la cita es de una agenda que su rol no ve. Sabe que está citado, y nada
  // más (lo decide el servidor).
  if (citado.sin_detalle) {
    return <span className="block font-medium" data-testid="lead-citado-sin-detalle">Sí</span>;
  }
  return (
    <span className="block">
      <Link to={`/pacientes/${citado.paciente_id}`} className="text-[#2E6E5E] hover:underline font-medium"
        data-testid={`lead-citado-paciente-${citado.paciente_id}`}>
        {citado.paciente_nombre || 'Ver ficha'}
      </Link>
      {' · '}
      {citado.proxima ? 'cita el ' : 'última cita el '}
      {fechaDeCita(citado.fecha, citado.hora)}
      {citado.agenda_nombre ? (
        <span data-testid="lead-citado-agenda">
          {' · en '}<span className="font-medium">{citado.agenda_nombre}</span>
        </span>
      ) : null}
    </span>
  );
}

/**
 * «Prioridad alta» (16/10/2026): cumple una de las reglas de «Prioridad de los
 * contactos» de su campaña (las pone dirección en Campañas). El porqué, al
 * pasar por encima.
 */
function PrioridadAlta({ prioridad, testid }) {
  if (!prioridad) return null;
  // Desde el 31/10/2026, el NIVEL del orden de Pendientes: su nombre (lo pone
  // dirección en Campañas); el «Prioridad alta» de antes es el nivel 1. El
  // primero, en rojo; los demás, discretos.
  const nombre = prioridad.nombre || 'Prioridad alta';
  const primero = !prioridad.nivel || prioridad.nivel === 1;
  return (
    <span data-testid={testid} title={prioridad.motivo || nombre} data-nivel={prioridad.nivel || 1}
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[11px] font-semibold ${primero
        ? 'border-rose-300 bg-rose-50 text-rose-800' : 'border-gray-200 bg-gray-50 text-gray-700'}`}>
      {nombre}
    </span>
  );
}

/**
 * «Ya era paciente» (16/10/2026): solo tiene citas ANTERIORES a cuando
 * preguntó. Sigue en su lista para llamarle; no cuenta como citado de la
 * campaña. Enlaza su ficha.
 */
function YaEraPaciente({ previo, testid }) {
  if (!previo) return null;
  const clases = 'inline-flex items-center rounded border border-sky-300 bg-sky-50 px-1.5 py-0.5 text-[11px] font-medium text-sky-800';
  // `sin_detalle` (22/10/2026): sin fechas ni agenda de una cita que su rol no
  // ve, y sin enlace (ver `CitaDelLead`).
  if (previo.sin_detalle) {
    return (
      <span data-testid={testid} className={clases}
        title="Ya era paciente cuando preguntó: no cuenta como citado de la campaña.">
        Ya era paciente
      </span>
    );
  }
  const ultima = fechaDeCita(previo.fecha, previo.hora);
  const en = previo.agenda_nombre ? ` en ${previo.agenda_nombre}` : '';
  // Una cita futura reservada ANTES de que preguntara tampoco la trajo la campaña.
  const titulo = previo.proxima
    ? `Ya era paciente: tiene cita${ultima ? ` el ${ultima}` : ''}${en}, reservada antes de que preguntara. No cuenta como citado de la campaña.`
    : `Ya era paciente: su última cita${ultima ? ` fue el ${ultima}` : ''}${en}, antes de preguntar. No cuenta como citado de la campaña.`;
  return (
    <Link to={`/pacientes/${previo.paciente_id}`} data-testid={testid} title={titulo}
      className={`${clases} hover:underline`}>
      Ya era paciente
    </Link>
  );
}

/** En «Ya citados» (16/10/2026): a quién le falta la fecha de nacimiento o el
 *  sexo (se completa en su ficha). */
function SinEdadOSexo({ edadSexo, testid }) {
  if (!edadSexo || (edadSexo.fecha && edadSexo.sexo)) return null;
  const falta = [!edadSexo.fecha ? 'fecha de nacimiento' : '', !edadSexo.sexo ? 'sexo' : '']
    .filter(Boolean).join(' y ');
  return (
    <span className="block text-amber-700" data-testid={testid}
      title="Se completa en su ficha (Editar), o al marcarlo «Citado» desde Leads">
      Sin {falta}
    </span>
  );
}

/** Marcado «Citado» a mano (30/09/2026): quién y cuándo. */
function CitadoAMano({ marca }) {
  if (!marca?.at) return null;
  return (
    <span className="block text-muted-foreground" data-testid="lead-citado-a-mano">
      Marcado citado{marca.por_nombre ? ` por ${marca.por_nombre}` : ''} · {entradaLegible(marca.at)}
    </span>
  );
}

/** Por qué se descartó, quién y cuándo. */
function DescarteDelLead({ descartado }) {
  if (!descartado) return null;
  return (
    <span>
      <span className="text-foreground">{descartado.motivo}</span>
      <span className="block text-muted-foreground">
        {[descartado.por_nombre, cuando(descartado.at)].filter(Boolean).join(' · ')}
      </span>
    </span>
  );
}

function Dato({ etiqueta, children, testid }) {
  return (
    <div className="grid grid-cols-[9rem_1fr] gap-2 py-1 text-sm">
      <span className="text-muted-foreground">{etiqueta}</span>
      <span data-testid={testid} className="break-words">{children}</span>
    </div>
  );
}

/**
 * Lo que dice la ficha de las ofertas (12/10/2026): «Sí (Sí, quiero
 * recibirlas)», «No (No, gracias)» o, si no se sabe leer, lo que contestó y
 * que no entra en la lista. No dice si sigue «en la lista»: eso es de la
 * lista de Marketing (puede haberse dado de baja después), no del lead.
 */
export function respuestaOfertasFicha(lead) {
  const ofertas = ofertasLegible(lead);
  if (!ofertas) return '';
  const contesto = lead.ofertas_respuesta || '';
  if (ofertas === '?') return `«${contesto}»: no se sabe si es sí o no, no entra en la lista de ofertas`;
  return contesto && contesto !== ofertas ? `${ofertas} (${contesto})` : ofertas;
}

/**
 * Una respuesta del formulario de Meta con su pregunta debajo, tal y como la
 * hizo el formulario (30/09/2026): un «Sí» a secas no se entiende sin
 * saber qué se preguntó (y a qué precio). Sin pregunta guardada, solo la
 * respuesta, como un `Dato`.
 */
function RespuestaConPregunta({ etiqueta, respuesta, pregunta, testid }) {
  return (
    <div className="grid grid-cols-[9rem_1fr] gap-2 py-1 text-sm">
      <span className="text-muted-foreground">{etiqueta}</span>
      <span className="break-words">
        <span data-testid={testid}>{respuesta}</span>
        {respuesta && pregunta ? (
          <span className="block text-xs text-muted-foreground" data-testid={`${testid}-pregunta`}>
            {pregunta}
          </span>
        ) : null}
      </span>
    </div>
  );
}

/**
 * La procedencia en la ficha: cuál es y por qué, y ponerla a mano (manda
 * sobre todo, también sobre la campaña de Meta). Con «Otras», cuál es
 * (30/09/2026): se escribe y se guarda con su botón.
 */
function ProcedenciaDeLaFicha({ lead, opciones, asignando, onAsignar, soloLectura = false }) {
  const procedencia = lead.procedencia;
  const aMano = procedencia?.regla === 'a_mano';
  const otrasAMano = aMano && procedencia?.clave === OTRAS;
  const [eligiendoOtras, setEligiendoOtras] = useState(false);
  const [detalle, setDetalle] = useState(otrasAMano ? procedencia.detalle || '' : '');
  // Otro contacto (o lo que ha guardado el servidor): se empieza de cero.
  useEffect(() => {
    setEligiendoOtras(false);
    setDetalle(otrasAMano ? procedencia?.detalle || '' : '');
  }, [lead.id, otrasAMano, procedencia?.detalle]);
  if (!procedencia) return null;
  const conDetalle = eligiendoOtras || otrasAMano;
  const guardarOtras = () => onAsignar(lead, OTRAS, detalle);
  const sinCambios = otrasAMano && (detalle.trim() === (procedencia.detalle || ''));
  return (
    <div className="rounded-md border p-3 space-y-2" data-testid="lead-ficha-procedencia">
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-sm text-muted-foreground shrink-0">Procedencia</span>
        <ProcedenciaLead procedencia={procedencia} testid="lead-ficha-procedencia-chip" />
      </div>
      {procedencia.explicacion ? (
        <p className="text-xs text-muted-foreground" data-testid="lead-ficha-procedencia-explicacion">
          {procedencia.explicacion}
        </p>
      ) : null}
      {soloLectura ? null : (
      <div className="flex flex-wrap items-center gap-2 pt-1">
        <Label htmlFor="lead-ficha-procedencia-elegir" className="text-xs text-muted-foreground font-normal">
          {aMano ? 'Cambiar a mano:' : 'Poner a mano:'}
        </Label>
        <SelectorProcedencia id="lead-ficha-procedencia-elegir" testid="lead-ficha-procedencia-elegir"
          className="w-auto max-w-full" value={eligiendoOtras ? OTRAS : (aMano ? procedencia.clave : '')}
          actual={aMano ? procedencia : null} opciones={opciones}
          vacio={aMano ? 'Elige otra…' : 'Elige…'} disabled={asignando}
          onChange={(v) => {
            if (v === OTRAS) { setEligiendoOtras(true); return; }
            setEligiendoOtras(false);
            if (v) onAsignar(lead, v);
          }} />
        {aMano ? (
          <Button type="button" size="sm" variant="ghost" disabled={asignando}
            data-testid="lead-ficha-quitar-procedencia" onClick={() => onAsignar(lead, null)}>
            Quitar
          </Button>
        ) : null}
      </div>
      )}
      {conDetalle && !soloLectura ? (
        <div className="flex flex-wrap items-center gap-2" data-testid="lead-ficha-procedencia-otras">
          <DetalleOtras id="lead-ficha-procedencia-detalle" testid="lead-ficha-procedencia-detalle"
            className="flex-1 min-w-[10rem]" value={detalle} onChange={setDetalle} disabled={asignando}
            onEnter={() => { if (!sinCambios) guardarOtras(); }} />
          <Button type="button" size="sm" disabled={asignando || sinCambios}
            data-testid="lead-ficha-procedencia-otras-guardar" onClick={guardarOtras}>
            {otrasAMano ? 'Guardar cuál' : 'Poner «Otras»'}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

/**
 * La ficha de un lead: sus datos y, sobre todo, de qué marca viene y POR QUÉ.
 * Si escribió a los dos correos se dice (cuenta el primero). Si el correo no
 * dice la marca, aquí se asigna a mano; el servidor apunta quién y cuándo.
 */
function FichaLead({
  lead, marcas, onClose, asignando, onAsignar, descartando, onDescartar, onRecuperar,
  opcionesProcedencia, asignandoProcedencia, onAsignarProcedencia, citando, onCitar,
  soloLectura = false,
}) {
  const [motivo, setMotivo] = useState('');
  const [pidiendo, setPidiendo] = useState(false);
  // Otro contacto, otro motivo: lo escrito para el anterior no se arrastra.
  useEffect(() => { setMotivo(''); setPidiendo(false); }, [lead?.id]);
  if (!lead) return null;
  const buzones = lead.buzones || [];
  const aMano = lead.marca_regla === 'a_mano';
  const entro = entroEn(lead);
  return (
    <Dialog open onOpenChange={(abierta) => { if (!abierta) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="lead-ficha">
        <DialogHeader><DialogTitle>Ficha del contacto</DialogTitle></DialogHeader>

        <div className="rounded-md border p-3 space-y-2" data-testid="lead-ficha-marca">
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">Viene de</span>
            <MarcaLead marca={lead.marca} testid="lead-ficha-chip" marcas={marcas} />
          </div>
          {lead.marca_explicacion ? (
            <p className="text-xs text-muted-foreground" data-testid="lead-ficha-explicacion">
              {lead.marca_explicacion}
            </p>
          ) : null}
          {lead.escribio_a_los_dos ? (
            <p className="text-xs font-medium text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1"
              data-testid="lead-ficha-los-dos">
              Escribió a más de un correo. La marca es la del primero.
            </p>
          ) : null}
          {buzones.length ? (
            <ul className="text-xs space-y-1" data-testid="lead-ficha-buzones">
              {buzones.map((b, i) => (
                <li key={b.buzon} className="flex items-center gap-2">
                  <span className="text-muted-foreground w-16">{i === 0 ? 'Primero' : 'Después'}</span>
                  <MarcaLead marca={b.marca} marcas={marcas} />
                  {cuando(b.desde) ? <span className="text-muted-foreground">{cuando(b.desde)}</span> : null}
                </li>
              ))}
            </ul>
          ) : null}
          {soloLectura ? null : lead.puede_asignar_marca ? (
            <div className="flex flex-wrap items-center gap-2 pt-1" data-testid="lead-ficha-asignar">
              <span className="text-xs text-muted-foreground">
                {aMano ? 'Cambiar a mano:' : 'Asignar a mano:'}
              </span>
              {(marcas || []).map((m) => (
                <Button key={m.clave} type="button" size="sm" variant="outline"
                  disabled={asignando || (aMano && lead.marca === m.clave)}
                  data-testid={`lead-ficha-asignar-${m.clave}`}
                  onClick={() => onAsignar(lead, m.clave)}>
                  {m.nombre}
                </Button>
              ))}
              {aMano ? (
                <Button type="button" size="sm" variant="ghost" disabled={asignando}
                  data-testid="lead-ficha-quitar-marca" onClick={() => onAsignar(lead, null)}>
                  Quitar
                </Button>
              ) : null}
            </div>
          ) : (
            <p className="text-xs text-muted-foreground" data-testid="lead-ficha-sin-asignar">
              La marca la dice su correo: no se cambia a mano.
            </p>
          )}
        </div>

        {/* De dónde viene (27/09/2026): qué procedencia tiene y por qué, y
            ponerla a mano (manda sobre todo, también sobre la campaña de Meta). */}
        <ProcedenciaDeLaFicha lead={lead} opciones={opcionesProcedencia}
          asignando={asignandoProcedencia} onAsignar={onAsignarProcedencia} soloLectura={soloLectura} />

        {/* Lo que esa persona no dio sale en blanco, como en la lista. */}
        <div>
          <Dato etiqueta="Nombre" testid="lead-ficha-nombre">{lead.nombre}</Dato>
          <Dato etiqueta="Teléfono" testid="lead-ficha-telefono">
            {lead.telefono ? telefonoConPrefijo(lead.telefono) : ''}
          </Dato>
          <Dato etiqueta="Correo" testid="lead-ficha-email">{lead.email}</Dato>
          <Dato etiqueta="Motivo" testid="lead-ficha-motivo">{lead.motivo}</Dato>
          <Dato etiqueta="De dónde viene" testid="lead-ficha-origen">{lead.origen}</Dato>
          {/* Del formulario de Meta (27/09/2026): lo que eligió y de dónde. */}
          {lead.meta ? (
            <>
              <Dato etiqueta="Tratamiento" testid="lead-ficha-tratamiento">{lead.tratamiento}</Dato>
              <Dato etiqueta="Qué quiere mejorar" testid="lead-ficha-mejorar">{lead.mejorar}</Dato>
              <Dato etiqueta="Presupuesto" testid="lead-ficha-presupuesto">{lead.presupuesto}</Dato>
              {/* La valoración (30/09/2026), con la pregunta del formulario. */}
              <RespuestaConPregunta etiqueta={ETIQUETA_MODALIDAD_VALORACION}
                respuesta={lead.modalidad_valoracion} pregunta={lead.meta.preguntas?.modalidad_valoracion}
                testid="lead-ficha-modalidad-valoracion" />
              <RespuestaConPregunta etiqueta={ETIQUETA_PAGO_VALORACION}
                respuesta={lead.pago_valoracion} pregunta={lead.meta.preguntas?.pago_valoracion}
                testid="lead-ficha-pago-valoracion" />
              {/* Cuándo quiere operarse (02/10/2026), con su pregunta. */}
              <RespuestaConPregunta etiqueta={ETIQUETA_PLAZO}
                respuesta={lead.plazo} pregunta={lead.meta.preguntas?.plazo}
                testid="lead-ficha-plazo" />
              {/* Si quiere recibir ofertas (12/10/2026): sí o no, lo que
                  contestó y la pregunta tal y como la hizo el formulario. */}
              <RespuestaConPregunta etiqueta={ETIQUETA_OFERTAS}
                respuesta={respuestaOfertasFicha(lead)} pregunta={lead.meta.preguntas?.ofertas}
                testid="lead-ficha-ofertas" />
              {/* La ciudad, o la provincia si es lo que preguntó el formulario. */}
              <Dato etiqueta="Ciudad / provincia" testid="lead-ficha-ciudad">{lead.ciudad}</Dato>
              <Dato etiqueta="Campaña" testid="lead-ficha-campana">{lead.meta.campaign_name}</Dato>
              <Dato etiqueta="Conjunto de anuncios" testid="lead-ficha-conjunto">{lead.meta.adset_name}</Dato>
              <Dato etiqueta="Anuncio" testid="lead-ficha-anuncio">{lead.meta.ad_name}</Dato>
              <Dato etiqueta="Plataforma" testid="lead-ficha-plataforma">{plataformaLegible(lead.meta.plataforma)}</Dato>
              {(lead.meta.otras_respuestas || []).map((o) => (
                <Dato key={o.campo} etiqueta={o.campo}>{respuestaLegible(o.valor)}</Dato>
              ))}
            </>
          ) : null}
          {/* Del formulario de la web (28/09/2026): lo que eligió y el correo
              del que salió, en Mail. */}
          {!lead.meta && lead.correo?.mensaje_id ? (
            <>
              <Dato etiqueta="Tratamiento" testid="lead-ficha-tratamiento">{lead.tratamiento}</Dato>
              <Dato etiqueta="Ciudad" testid="lead-ficha-ciudad">{lead.ciudad}</Dato>
              <Dato etiqueta="Formulario web" testid="lead-ficha-formulario-web">
                <Link to={enlaceAlCorreo(lead.correo)} className="inline-flex items-center gap-1 hover:underline"
                  data-testid="lead-ficha-ver-correo">
                  <Mail className="w-3 h-3" /> Ver el correo en Mail
                </Link>
              </Dato>
            </>
          ) : null}
          <Dato etiqueta="Entró" testid="lead-ficha-entro">
            {`${entradaLegible(entro, { conAno: true })}${recogidoDespues(lead) ? ` · ${recogidoDespues(lead)}` : ''}${lead.created_by_nombre ? ` · apuntado por ${lead.created_by_nombre}` : ''}`}
          </Dato>
          <Dato etiqueta="Contactado" testid="lead-ficha-contactado">
            {lead.contactado
              ? `${lead.contactado_via === 'conector' ? 'el conector' : (lead.contactado_por_nombre || '')} ${entradaLegible(lead.contactado_at, { conAno: true })}`.trim()
              : ''}
          </Dato>
        </div>

        {/* Prioridad alta y «ya era paciente» (16/10/2026), con su porqué. */}
        {lead.prioridad ? (
          <p className="rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-900"
            data-testid="lead-ficha-prioridad">
            <span className="font-semibold">{lead.prioridad.nombre || 'Prioridad alta'}. </span>
            {String(lead.prioridad.motivo || '')
              .replace(`${lead.prioridad.nombre || 'Prioridad alta'} porque `, 'Porque ')}
          </p>
        ) : null}
        {lead.ya_era_paciente ? (
          <div className="rounded-md border border-sky-200 bg-sky-50 p-3 text-sm" data-testid="lead-ficha-ya-paciente">
            <span className="font-medium">Ya era paciente cuando preguntó: </span>
            <CitaDelLead citado={lead.ya_era_paciente} />
            <span className="block text-xs text-muted-foreground">
              No cuenta como citado de la campaña hasta que tenga una cita nueva (o se marque «Citado»).
            </span>
          </div>
        ) : null}

        {lead.citado || lead.citado_a_mano?.at ? (
          <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm space-y-1" data-testid="lead-ficha-citado">
            {lead.citado ? (
              <div>
                <span className="font-medium">Ya es paciente con cita: </span>
                <CitaDelLead citado={lead.citado} />
              </div>
            ) : null}
            {lead.citado_a_mano?.at ? (
              <div className="flex flex-wrap items-center gap-2">
                <CitadoAMano marca={lead.citado_a_mano} />
                {soloLectura ? null : (
                  <Button type="button" size="sm" variant="outline" disabled={citando}
                    data-testid="lead-ficha-quitar-citado" onClick={() => onCitar(lead, false)}>
                    <Undo2 className="w-4 h-4 mr-1" /> Quitar citado
                  </Button>
                )}
              </div>
            ) : null}
          </div>
        ) : null}

        {/* Descartar (27/09/2026): no se borra; se recupera desde «Descartados». */}
        {lead.descartado ? (
          <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm space-y-2"
            data-testid="lead-ficha-descartado">
            <div>
              <span className="font-medium">Descartado: </span>
              <DescarteDelLead descartado={lead.descartado} />
            </div>
            {soloLectura ? null : (
              <Button type="button" size="sm" variant="outline" disabled={descartando}
                data-testid="lead-ficha-recuperar" onClick={() => onRecuperar(lead)}>
                <ArchiveRestore className="w-4 h-4 mr-1" /> Recuperar
              </Button>
            )}
          </div>
        ) : pidiendo && !soloLectura ? (
          <div className="rounded-md border p-3 space-y-2" data-testid="lead-ficha-descartar-form">
            <Label htmlFor="lead-ficha-descartar-motivo">¿Por qué se descarta?</Label>
            <Input id="lead-ficha-descartar-motivo" value={motivo} maxLength={200}
              data-testid="lead-ficha-descartar-motivo" placeholder="Ya no vale, spam, repetido…"
              onChange={(e) => setMotivo(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && motivo.trim()) onDescartar(lead, motivo.trim()); }} />
            <p className="text-xs text-muted-foreground">
              Sale de la lista y de los números, pero no se borra: se recupera desde «Descartados».
            </p>
            <div className="flex gap-2">
              <Button type="button" size="sm" disabled={descartando || !motivo.trim()}
                data-testid="lead-ficha-descartar-confirmar" onClick={() => onDescartar(lead, motivo.trim())}>
                {descartando ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Archive className="w-4 h-4 mr-1" />}
                Descartar
              </Button>
              <Button type="button" size="sm" variant="ghost" onClick={() => setPidiendo(false)}>Cancelar</Button>
            </div>
          </div>
        ) : null}

        <DialogFooter>
          {!lead.descartado && !pidiendo && !soloLectura ? (
            <Button variant="ghost" onClick={() => setPidiendo(true)} className="mr-auto"
              data-testid="lead-ficha-descartar">
              <Archive className="w-4 h-4 mr-1" /> Descartar
            </Button>
          ) : null}
          <Button variant="outline" onClick={onClose} data-testid="lead-ficha-cerrar">Cerrar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
